import React, { useEffect, useMemo, useState, useCallback } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
   Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Dialog,
    FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  DialogActions, DialogContent,  DialogContentText, DialogTitle, CardContent,
  Autocomplete, Paper,  Avatar,
  FormGroup, Checkbox, Popover, Tooltip, Chip, InputAdornment,
  Tabs, Tab, Divider, Alert, IconButton,
} from "@mui/material";
import { useNavigate, useParams, Link } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useStyles } from "../../../theme/appStyles";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import {
  useGetCategoryQuery,
  useGetPrinterQuery,
  useGetProductBrandQuery,
  useGetVariantQuery,
  useGetProductTagQuery,
  useDeleteVariantMutation,
  useGetModifierGroupQuery,
  useGetModifierGrpQuery,
  useGetModifierQuery,
  useGetProductCategoryQuery,
  useGetShopQuery,
  useGetShopProductQuery,
  useGetRouteQuery,
  useGetShopOrdersQuery,
  useCreateShopOrderMutation,
  useCreateShopInvoiceMutation,
  useUpdateShopOrderStatusMutation,
  useGetSubCategoryByArrayQuery,
  useGetSerializedItemQuery,
  useGetSoldQuery,
  useGetInventoryQuery,
  useGetCoursingQuery,
  useGetDepartmentQuery,
  useGetTaxQuery,
  useGetProductQuery,
  useGetLoopingTableQuery,
  useDeleteProductMutation,
  useReorderProductMutation,
  useUpdateShopProductPriceMutation,
} from "../../../Api/attoDeskApi";
import {
  ICategory,
  IShop,
  IPrinter,
  IProduct,
  IProductBrand,
  IProductTag,
  IProductPopUP,
  IVariantPopUP,
  IModifierGroupPopUp,
  IModifierGrpPopUp,
  IModifierPopUp,
  ModifierInfo,
  ProductInfo,
  ISerializedItem,
  ISold,
  IProductInventory,
    ICoursing,
    IDepartment,
    ITaxes,
    ILoopingTable,
    IShopProduct,
    IRoutes,
    IShopOrder,
    IShopOrderItem,
} from "../../../Api/Interface/api.interface";
import { SizeOfLevelType } from "../../../Core/Enum/enum";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import Barcode from "react-barcode";
import placeholderImage from '../../../Images/fav.png';
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import { useNotifier } from "../../../Core/Notifier";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import { Dayjs } from "dayjs";
import Switch, { SwitchProps } from "@mui/material/Switch";
import axios from "axios";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import PaymentIcon from "@mui/icons-material/Payment";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import CategoryIcon from "@mui/icons-material/Category";
import GroupsIcon from "@mui/icons-material/Groups";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import LoopIcon from "@mui/icons-material/Loop";
import PointOfSaleIcon from '@mui/icons-material/PointOfSale'; 
import { styled, Theme, CSSObject } from "@mui/material/styles";
import LinkIcon from '@mui/icons-material/Link';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import BlockIcon from '@mui/icons-material/Block';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { string } from "yup";
import moment from "moment";
import {
  DragDropContext,
  Droppable,
  Draggable
} from "@hello-pangea/dnd";


import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Pagination from "../../../Components/Pagination";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { CiSearch } from "react-icons/ci";
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from "@mui/icons-material/Check";
import { cornersOfRectangle } from "@dnd-kit/core/dist/utilities/algorithms/helpers";
import { CategoryOutlined } from "@mui/icons-material";
import LanguageIcon from '@mui/icons-material/Language'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

import SortIcon from '@mui/icons-material/Sort';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import CreateShopProduct from "../Components/CreateShopProductModal";
import { rowSelectionStateInitializer } from "@mui/x-data-grid/internals";
import DirectionsIcon from '@mui/icons-material/Directions';
import NewPopUpCustomer from "../Edit/index";
import ModeEditIcon from "@mui/icons-material/ModeEdit";



interface ModifierGroupSelection {
  id?: number;
  modifierGroupId: number;
  required: boolean;
  minimum: number;
  maximum: number;
  order: number | null;
  modifiers?:ModifierInfo[];
}

interface ModifierGrpSelection {
  id?: number;
  modifierGroupId: number;
  modifierGroupName: string;
  minimum: number | string;
  maximum: number | string;
  modifiers?:ProductInfo[];
  order? : number;
}

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(28px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.primary,
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 30, // Increased thumb size
    height: 30, // Increased thumb size
  },
  "& .MuiSwitch-track": {
    borderRadius: 34 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#757575" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`, // Using SVG path for check
      left: 12,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`, // Using SVG path for minus
      right: 12,
    },
  },
}));

const isPrinterArray = (data: any): data is IPrinter[] => {
  return (
    Array.isArray(data) &&
    data.every(
      (item) =>
        "id" in item && "printerName" in item && "printerDescription" in item
    )
  );
};




const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQueryStock, setSearchQueryStock] = useState("");
  const [searchQuerySale, setSearchQuerySale] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [page, setPage] = useState(0);
  const [selectedModifierGroupIds, setSelectedModifierGroupIds] = useState<number[]>([]);

    const [selectedProduct, setSelectedProduct] = useState<IProductPopUP | null>(
      null
    );
     const getFormattedDate = (createDate: Dayjs | null): string => {
        return createDate ? createDate.format("YYYY-MM-DD") : "";
      };

     const [selectedProductBrandId, setSelectedProductBrandId] =
        useState<string>("");
      const [selectedProductCategoryId, setSelectedProductCategoryId] =
        useState<string>("");
      const [selectedProductTagIds, setSelectedProductTagIds] = useState<string[]>(
        []
      );
       const [selectedProductViewOnline, setSelectedProductViewOnline] =
          useState<string>("");
        const [startDate, setStartDate] = useState<Dayjs | null>(null);
          const [endDate, setEndDate] = useState<Dayjs | null>(null);
          const startDateAsDate = startDate?.toDate() || null;
          const endDateAsDate = endDate?.toDate() || null;
          const [createDate, setCreateDate] = useState<Dayjs | null>(null);
          const [currentSearchQuery, setCurrentSearchQuery] = useState("");
          const [currentSearchQueryStock, setCurrentSearchQueryStock] = useState("");
          const [currentSearchQuerySale, setCurrentSearchQuerySale] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [openCreateVariantDialog, setOpenCreateVariantDialog] = useState(false);
    const { showErrorMessage, showMessage } = useNotifier();
    const [openDeleteProduct, setOpenDeleteProduct] = useState(false);
    const [productToDelete, setProductToDelete] = useState<IProductPopUP | null>(
      null
    );
  const [selectedCard, setSelectedCard] = useState<string | null>("Product");

  const API_URL = (process.env.REACT_APP_API_URL || "").trim();


const [selectedLinkedProductId, setSelectedLinkProductId] = useState<number | null>(null);
const [showLinkedProductPopup, setShowLinkedProductPopup] = useState(false);
const [productSearchTerm, setProductSearchTerm] = useState("");
const [productSearchResults, setProductSearchResults] = useState([]);
const [selectedModifierGrpIds, setSelectedModifierGrpIds] = useState<string[]>([]);
const [activeGroup, setActiveGroup] = useState<ModifierGrpSelection | null>(null);
const [viewMode, setViewMode] = useState<String>("groupList");
const [selectedRows, setSelectedRows] = useState<Record<number, boolean>>({});


const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
const [openPriceDialog, setOpenPriceDialog] = useState(false);
const [priceValue, setPriceValue] = useState("");
const [searchText, setSearchText] = React.useState("");
const [showOrderPopup, setShowOrderPopup] = React.useState(false);
const [orderList, setOrderList] = useState<IModifierGrpPopUp[]>([]);
// For serialized popup
const [selectedSerialized, setSelectedSerialized] = useState<ISerializedItem | null>(null);
const [openSerialized, setOpenSerialized] = useState(false);
const debouncedSearchQuery = useDebounce(searchQueryStock, 300);
const debouncedSearchQuerySale = useDebounce(searchQuerySale, 300);
const [isImporting, setIsImporting] = useState(false);
const [orderedProductIds, setOrderedProductIds] = useState<number[]>([]);
const [layoutMode, setLayoutMode] = useState(false);
const [draggableProducts, setDraggableProducts] = useState<IProductPopUP[]>([]);
const [openDialogShop, setOpenDialogShop] = useState(false);
const [selectedShopProducts, setSelectedShopProducts] = useState<number[]>([]);
const [openRouteModal, setOpenRouteModal] = React.useState(false);
const [selectedRoutes, setSelectedRoutes] = React.useState<IRoutes[]>([]); // start with empty array
const [isAssigningRoute, setIsAssigningRoute] = React.useState(false);
const [shopAssignedRoutes, setShopAssignedRoutes] = React.useState<IRoutes[]>([]);
const [routeIds, setRouteIds] = React.useState<number[]>([]);
const [productIds, setProductIds] = React.useState<number[]>([]);

   const [reorderProduct] = useReorderProductMutation();
const [updateShopProductPrice] = useUpdateShopProductPriceMutation();
const [createShopOrder] = useCreateShopOrderMutation();
const [createShopInvoice] = useCreateShopInvoiceMutation();
const [updateShopOrderStatus] = useUpdateShopOrderStatusMutation();
// { productId -> { shopProductId, custom_price } }
const [editingPrice, setEditingPrice] = useState<{ productId: string; value: string } | null>(null);
const [savingPriceId, setSavingPriceId] = useState<string | null>(null);
const [openOrderModal, setOpenOrderModal] = useState(false);
const [orderCart, setOrderCart] = useState<Record<number, number>>({});
const [orderNotes, setOrderNotes] = useState("");
const [submittingOrder, setSubmittingOrder] = useState(false);
const [orderStatusFilter, setOrderStatusFilter] = useState<string>("all");
const [viewOrder, setViewOrder] = useState<IShopOrder | null>(null);
const [editOrderItems, setEditOrderItems] = useState<IShopOrderItem[]>([]);
const [editOrderNotes, setEditOrderNotes] = useState("");
const [savingOrder, setSavingOrder] = useState(false);
const [openPortalSetup, setOpenPortalSetup] = useState(false);
const [portalEmail, setPortalEmail] = useState("");
const [portalPassword, setPortalPassword] = useState("");
const [savingPortal, setSavingPortal] = useState(false);
const [portalSetupMsg, setPortalSetupMsg] = useState("");
const [portalStatus, setPortalStatus] = useState<{ portal_email: string | null; has_password: boolean; is_active: boolean } | null>(null);
const [portalBusy, setPortalBusy] = useState(false);
const [portalTempPwd, setPortalTempPwd] = useState<string | null>(null);
const [resetPwdDialogOpen, setResetPwdDialogOpen] = useState(false);
const [resetPwdResultOpen, setResetPwdResultOpen] = useState(false);
const [disableAccessDialogOpen, setDisableAccessDialogOpen] = useState(false);
const [tempPwdInput, setTempPwdInput] = useState("");
const [showTempPwd, setShowTempPwd] = useState(true);
const [savingTempPwd, setSavingTempPwd] = useState(false);

// Invoice & Payment state
const [shopInvoices, setShopInvoices] = useState<any[]>([]);
const [invoiceSummary, setInvoiceSummary] = useState<any>(null);
const [loadingInvoices, setLoadingInvoices] = useState(false);
const [bulkPaymentOpen, setBulkPaymentOpen] = useState(false);
const [bulkAmount, setBulkAmount] = useState("");
const [bulkMethod, setBulkMethod] = useState("Cash");
const [bulkNotes, setBulkNotes] = useState("");
const [bulkDate, setBulkDate] = useState(dayjs().format("YYYY-MM-DD"));
const [savingBulkPayment, setSavingBulkPayment] = useState(false);
const [selectedInvoiceIds, setSelectedInvoiceIds] = useState<Set<number>>(new Set());
const [creditData, setCreditData] = useState<any>(null);
const [creditDialogOpen, setCreditDialogOpen] = useState(false);
const [editCreditLimit, setEditCreditLimit] = useState("");
const [editCreditTerms, setEditCreditTerms] = useState("no_limit");
const [savingCredit, setSavingCredit] = useState(false);
const [editCreditBlocked, setEditCreditBlocked] = useState(false);
const [openEditShop, setOpenEditShop] = useState(false);
const [orderDate, setOrderDate] = useState(dayjs().format("YYYY-MM-DD"));

  const { id: CategoryId, id } = useParams<{ id: string }>();

  useEffect(() => {}, [CategoryId]);


  

    const { data, isLoading, isError, refetch } = useGetShopQuery({
      searchText: "",
      id: String(CategoryId),     
    });

  const { data : shopProductData, isLoading: shopProductLoading, isError: shopProductError } = useGetShopProductQuery({
  searchText: "",
  id: String(CategoryId),     
    });

 const { data : routeData, isLoading: routeLoading, isError: routeError } = useGetRouteQuery({
  searchText: "",
  id: String(CategoryId),
    });

  const { data: shopOrdersData, refetch: refetchOrders } = useGetShopOrdersQuery(
    Number(CategoryId),
    { skip: !CategoryId }
  );

    useEffect(() => {
      if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
        setCurrentSearchQueryStock(debouncedSearchQuery);
      //  refetch();
      }
    }, [debouncedSearchQuery]);





  const { data: soldData } = useGetSoldQuery({
     id: String(CategoryId),
    searchText:  currentSearchQuerySale,
});

const handleOpen = () => {
    setSelectedShopProducts(shopProductList.map((p) => p.product_id));
     setOpenDialogShop(true);
   
  };
    const handleClose = () => setOpenDialogShop(false);

   useEffect(() => {
      if (debouncedSearchQuerySale.length >= 4 || debouncedSearchQuerySale === "") {
        setCurrentSearchQuerySale(debouncedSearchQuerySale);
      //  refetch();
      }
    }, [debouncedSearchQuerySale]);
  

  const { data: productBrandData, isLoading: productBrandLoading } =
    useGetProductBrandQuery({
      searchText: "",
      isActive: true,
    });

  const { data: tagData, isLoading: tagLoading } = useGetProductTagQuery({
    searchText: "",
    isActive: true,
  });

  const { data: printerData, isLoading: printerLoading } = useGetPrinterQuery({
    searchText: "",
  });

  const { data: categoryData, isLoading: categoryLoading } =
    useGetCategoryQuery();

    const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
        null
      );
      const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<
        number | null
      >(null);
    
      const [selectedSubToSubCategoryId, setSelectedSubToSubCategoryId] = useState<
        number | null
      >(null);
    
      const [selectedSubToSubToSubCategoryId, setSelectedSubToSubToSubCategoryId] =
        useState<number | null>(null);
    
      const { data: subCategoryData, refetch: refetchSubCategories } =
        useGetSubCategoryByArrayQuery({
          parent_ids: selectedCategoryId ? [Number(selectedCategoryId)] : [],
        });
    
      const { data: subCategory2Data, refetch: refetchS2bCategories } =
        useGetSubCategoryByArrayQuery({
          parent_ids: selectedSubCategoryId
            ? [Number(selectedCategoryId), Number(selectedSubCategoryId)]
            : [],
        });
    
      const { data: subCategory3Data, refetch: refetchS3bCategories } =
        useGetSubCategoryByArrayQuery({
          parent_ids: selectedSubCategoryId
            ? [
                Number(selectedCategoryId),
                Number(selectedSubCategoryId),
                Number(selectedSubToSubCategoryId),
              ]
            : [],
        });
    
   
      const subCategoryList = useMemo(() => {
        return subCategoryData?.data as ICategory[];
      }, [subCategoryData?.data]);
    
      const subToSubCategoryList = useMemo(() => {
        return subCategory2Data?.data as ICategory[];
      }, [subCategory2Data?.data]);
    
      const subToSubToSubCategoryList = useMemo(() => {
        return subCategory3Data?.data as ICategory[];
      }, [subCategory3Data?.data]);
    
      const productCategoryId = selectedSubToSubToSubCategoryId
        ? Number(selectedSubToSubToSubCategoryId)
        : selectedSubToSubCategoryId
        ? Number(selectedSubToSubCategoryId)
        : selectedSubCategoryId
        ? Number(selectedSubCategoryId)
        : selectedCategoryId
        ? Number(selectedCategoryId)
        : String("");

  const product = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as IShop;
    }
    return null;
  }, [data]);


React.useEffect(() => {
  if (product?.route_ids) {
    const ids =
      typeof product.route_ids === "string"
        ? JSON.parse(product.route_ids)
        : product.route_ids;

    setRouteIds(ids || []);
  }
}, [product]);

React.useEffect(() => {
  if (product?.product_ids) {
    const ids =
      typeof product.product_ids === "string"
        ? JSON.parse(product.product_ids)
        : product.product_ids;

    setProductIds(ids || []); // similar to setRouteIds
  }
}, [product]);

 const { data: departmentData, isLoading: departmentLoading } =
    useGetDepartmentQuery({
      searchText: "",
    });
  const { data: coursingData, isLoading: coursingLoading } =
    useGetCoursingQuery({
      searchText: "",
    });
  const { data: taxData, isLoading: taxLoading } = useGetTaxQuery({
    searchText: "",
  });


  const departmentList = useMemo(() => {
     return departmentData?.data as IDepartment[];
   }, [departmentData?.data]);
 
   const coursingList = useMemo(() => {
     return coursingData?.data as ICoursing[];
   }, [coursingData?.data]);
 
   const taxList = useMemo(() => {
     return taxData?.data as ITaxes[];
   }, [taxData?.data]);

     const printerList = useMemo(() => {
       return printerData?.data as IPrinter[];
     }, [printerData?.data]);
 
   const categoryList = useMemo(() => {
     return categoryData?.data as ICategory[];
   }, [categoryData?.data]);

   const CategoryPrinterMap = useMemo(() => {
       const map = new Map();
       printerList?.forEach((printer) => {
         map.set(printer.id, printer.printerName);
       });
       return map;
     }, [printerList]);

       const { data: productData, isLoading: productIsLoading, refetch: productRefetch } = useGetProductQuery({
         productBrandId: selectedProductBrandId,
         productCategoryId: String(productCategoryId),
         productTagIds: selectedProductTagIds,
         productViewOnline: selectedProductViewOnline,
         createdDateStart: startDateAsDate as Date,
         createdDateEnd: endDateAsDate as Date,
         searchText: currentSearchQuery,
         createdDate: getFormattedDate(createDate),
         id: null,
       });

          const categoryMap = useMemo(() => {
     const map = new Map();
     categoryList?.forEach((printer) => {
       map.set(printer.id, printer.categoryName);
     });
     return map;
   }, [categoryList]);


     const productList: IProductPopUP[] = Array.isArray(productData?.data)
           ? (productData?.data as IProductPopUP[])
           : [];

  const shopProductList: IShopProduct[] = Array.isArray(shopProductData?.data)
           ? (shopProductData?.data as IShopProduct[])
           : [];

  // Convert string to number array safely




  const routeList: IRoutes[] = Array.isArray(routeData?.data)
           ? (routeData?.data as IRoutes[])
           : [];

  const routesArray: IRoutes[] = routeList.filter((route: IRoutes) =>
  routeIds.includes(route.id)
);

const filteredShopProducts: IProductPopUP[] = productIds
  .map((id) => productList.find((p) => Number(p.id) === id))
  .filter(Boolean) as IProductPopUP[];
  
const filteredRoutes = routeList
  .filter((r: IRoutes) => !routeIds.includes(r.id)) // remove already assigned
  .filter((r: IRoutes) =>
    r.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
 
   const departmentMap = useMemo(() => {
     const map = new Map();
     departmentList?.forEach((category) => {
       map.set(category.id, category.departmentName);
     });
     return map;
   }, [departmentList]);
 
   const coursingMap = useMemo(() => {
     const map = new Map();
     coursingList?.forEach((category) => {
       map.set(category.id, category.coursingName);
     });
     return map;
   }, [coursingList]);


 
   const taxMap = useMemo(() => {
     const map = new Map();
     taxList?.forEach((category) => {
       map.set(category.id, category.taxName);
     });
     return map;
   }, [taxList]);

    const { data: loopingTabeData, isLoading: loopingTableLoading } =
       useGetLoopingTableQuery({
         searchText: "",
       });
 
  const loopingTableList = useMemo(() => {
    return loopingTabeData?.data as ILoopingTable[];
  }, [loopingTabeData?.data]);

    const [deleteProduct] = useDeleteProductMutation();
 const handleDelete = async (id: string) => {
    try {
      const response = await deleteProduct(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteProduct(false);
      } else {
        showErrorMessage("Failed to delete the product");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the product");
    }
  };


  const cardsData = [
  // {
  //   title: "Active",
  //   value: product?.productCanSell,
  // },
  {
    title: "Product",
     value: filteredShopProducts?.length,
  },
   {
    title: "Route",
     value: routesArray?.length,
  },
  // {
  //   title: "POS",
  //   //value: product?.hidePos,
  // },
  {
    title: "Online",
   // value: product?.hideOnlineOrder,  // Adjust if needed differently
  },
  // {
  //   title: "Sales",
  //  // value: soldList?.length ?? 0 ,
  // },
  {
    title: "Looping",
  //  value: product?.categoryIsLooping,
  },
];

const cardIcons: Record<string, JSX.Element> = {
  Product: <Inventory2Icon sx={{ mr: 1 }} />,
  Route: <DirectionsIcon  sx={{ mr: 1 }} />,
  POS: <PointOfSaleIcon sx={{ mr: 1 }} />,
  Online: <LanguageIcon sx={{ mr: 1 }} />,
  // "Sales": <PointOfSaleIcon sx={{ mr: 1 }} />,
  Looping: <LoopIcon sx={{ mr: 1 }} />,
};


 const handleCreateOpenDialog = () => {
    setOpenCreateVariantDialog(true);
  };

  const handleCreateCloseDialog = () => {
    setOpenCreateVariantDialog(false);
  };

  const handleOpenDialog = (product: IProductPopUP) => {
    setSelectedProduct(product);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedProduct(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (product: IProductPopUP) => {
    setProductToDelete(product);
    setOpenDeleteProduct(true);
  };

  const handleCloseDeletePopup = () => {
    setProductToDelete(null);
    setOpenDeleteProduct(false);
  };

  
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  
const handleAssignRoutesToShop = (routes: IRoutes[]) => {
  if (!routes || routes.length === 0) return;

  setIsAssigningRoute(true);
  const token = localStorage.getItem("token") || "";

  // Merge with existing routeIds
  const route_ids = Array.from(new Set([...routeIds, ...routes.map(r => r.id)]));

  fetch(`${API_URL}/shops/${CategoryId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ route_ids }),
  })
    .then(async (res) => {
      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.message || "Failed to assign routes");
      }
      return res.json();
    })
    .then((data) => {
      showMessage("Routes assigned successfully");
      setRouteIds(data.shop.route_ids || []); // update local state
      setShopAssignedRoutes(data.shop.route_ids || []);
      //refetch();
    })
    .catch((err) => {
      console.error(err);
      showErrorMessage(err.message || "Failed to assign routes");
    })
    .finally(() => {
      setIsAssigningRoute(false);
      setSelectedRoutes([]);
    });
};

const handleDeleteRoute = async (routeId: number) => {
  try {
    const token = localStorage.getItem("token") || "";

    const updatedRouteIds = routeIds.filter((id) => id !== routeId);

    const res = await fetch(`${API_URL}/shops/${CategoryId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        route_ids: updatedRouteIds,
      }),
    });

    if (!res.ok) throw new Error("Failed to remove route");

    showMessage("Route removed successfully");

    // update state
    setRouteIds(updatedRouteIds);

  } catch (err) {
    console.error(err);
    showErrorMessage("Failed to remove route");
  }
};


const handleDeleteProduct = async (productId: number) => {
  try {
    const token = localStorage.getItem("token") || "";
    
    // Remove the product ID from the shop's product_ids array
  const updatedProductIds = productIds.filter((id: number) => id !== productId);

    const res = await fetch(`${API_URL}/shops/${CategoryId}/update-product`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        product_ids: updatedProductIds,
      }),
    });

    if (!res.ok) throw new Error("Failed to remove product");

    showMessage("Product removed successfully");

    // Update local state
   

    setProductIds(updatedProductIds);
    refetch();

  } catch (err) {
    console.error(err);
    showErrorMessage("Failed to remove product");
  }
};

  // Build a map: product_id → IShopProduct (for custom_price lookup)
  // Must be before any early returns to satisfy Rules of Hooks
  const shopProductMap = useMemo(() => {
    const map = new Map<number, IShopProduct>();
    shopProductList.forEach((sp) => map.set(sp.product_id, sp));
    return map;
  }, [shopProductList]);

  // ── Invoice Loading (must be before early returns) ──
  const loadInvoices = useCallback(async () => {
    if (!CategoryId) return;
    setLoadingInvoices(true);
    try {
      const tkn = localStorage.getItem("token") || "";
      const res = await fetch(`${API_URL}/shop-invoices/shop/${CategoryId}/summary`, {
        headers: { "Content-Type": "application/json", Accept: "application/json", Authorization: `Bearer ${tkn}` },
      });
      const d = await res.json();
      if (d.success) { setShopInvoices(d.invoices || []); setInvoiceSummary(d.summary || null); }
    } catch {} finally { setLoadingInvoices(false); }
  }, [CategoryId, API_URL]);

  useEffect(() => { if (selectedCard === "Invoices") loadInvoices(); }, [selectedCard, loadInvoices]);

  // ── Credit Status Loading ──
  const loadCreditStatus = useCallback(async () => {
    if (!CategoryId) return;
    try {
      const tkn = localStorage.getItem("token") || "";
      const res = await fetch(`${API_URL}/shops/${CategoryId}/credit-status`, {
        headers: { "Content-Type": "application/json", Accept: "application/json", Authorization: `Bearer ${tkn}` },
      });
      const d = await res.json();
      if (d.success) setCreditData(d.data);
    } catch {}
  }, [CategoryId, API_URL]);

  useEffect(() => { loadCreditStatus(); }, [loadCreditStatus]);

  // ── Portal Access Status ──
  const loadPortalStatus = useCallback(async () => {
    if (!CategoryId) return;
    try {
      const tkn = localStorage.getItem("token") || "";
      const res = await fetch(`${API_URL}/shops/${CategoryId}/portal-status`, {
        headers: { "Content-Type": "application/json", Accept: "application/json", Authorization: `Bearer ${tkn}` },
      });
      const d = await res.json();
      if (d.success) setPortalStatus({ portal_email: d.portal_email, has_password: d.has_password, is_active: d.is_active });
    } catch {}
  }, [CategoryId, API_URL]);

  useEffect(() => { loadPortalStatus(); }, [loadPortalStatus]);

  const handleCopyPortalLink = async () => {
    try {
      await navigator.clipboard.writeText(portalUrl);
      showMessage("Portal link copied");
    } catch { showErrorMessage("Could not copy link"); }
  };

  // Defensive JSON parser — if the server returns HTML (auth redirect, 5xx page),
  // surface a clear message instead of "Unexpected token '<'".
  const parseJsonSafely = async (res: Response): Promise<any> => {
    const text = await res.text();
    try { return JSON.parse(text); }
    catch {
      const looksHtml = /^\s*<!DOCTYPE|^\s*<html/i.test(text);
      throw new Error(
        looksHtml
          ? `Server returned HTML (status ${res.status}) — endpoint missing or auth expired. Try logging in again.`
          : `Invalid response (status ${res.status})`
      );
    }
  };

  const handleAdminResetPortalPwd = async () => {
    if (!portalStatus?.portal_email) {
      showErrorMessage("Set a portal email first.");
      return;
    }
    setPortalBusy(true);
    try {
      const tkn = localStorage.getItem("token") || "";
      const res = await fetch(`${API_URL}/shops/${CategoryId}/portal-reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest", Authorization: `Bearer ${tkn}` },
      });
      const d = await parseJsonSafely(res);
      if (d.success) {
        setPortalTempPwd(d.temp_password);
        setTempPwdInput(d.temp_password);
        setShowTempPwd(true);
        setResetPwdDialogOpen(false);
        setResetPwdResultOpen(true);
        loadPortalStatus();
      } else showErrorMessage(d.message || "Failed to reset password");
    } catch (e: any) { showErrorMessage(e?.message || "Failed to reset password"); }
    finally { setPortalBusy(false); }
  };

  const handleSaveEditedTempPwd = async () => {
    if (!portalStatus?.portal_email) { showErrorMessage("Set a portal email first."); return; }
    if (tempPwdInput.length < 6) { showErrorMessage("Password must be at least 6 characters"); return; }
    setSavingTempPwd(true);
    try {
      const tkn = localStorage.getItem("token") || "";
      const res = await fetch(`${API_URL}/shops/${CategoryId}/portal-credentials`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest", Authorization: `Bearer ${tkn}` },
        body: JSON.stringify({ portal_email: portalStatus.portal_email, portal_password: tempPwdInput }),
      });
      const d = await parseJsonSafely(res);
      if (d.success) {
        showMessage("Password saved");
        setResetPwdResultOpen(false);
        setPortalTempPwd(null);
        setTempPwdInput("");
        loadPortalStatus();
      } else showErrorMessage(d.message || "Failed to save password");
    } catch (e: any) { showErrorMessage(e?.message || "Failed to save password"); }
    finally { setSavingTempPwd(false); }
  };

  const performTogglePortalActive = async (next: boolean) => {
    setPortalBusy(true);
    try {
      const tkn = localStorage.getItem("token") || "";
      const res = await fetch(`${API_URL}/shops/${CategoryId}/portal-toggle-active`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest", Authorization: `Bearer ${tkn}` },
        body: JSON.stringify({ is_active: next }),
      });
      const d = await parseJsonSafely(res);
      if (d.success) {
        showMessage(d.message);
        setDisableAccessDialogOpen(false);
        loadPortalStatus();
      } else showErrorMessage(d.message || "Failed");
    } catch (e: any) { showErrorMessage(e?.message || "Failed to update status"); }
    finally { setPortalBusy(false); }
  };

  const handleTogglePortalActive = () => {
    if (!portalStatus) return;
    if (portalStatus.is_active) {
      // Disabling — confirm via modal
      setDisableAccessDialogOpen(true);
    } else {
      // Enabling is non-destructive → just do it
      performTogglePortalActive(true);
    }
  };

  const handleSaveCreditSettings = async () => {
    setSavingCredit(true);
    try {
      const tkn = localStorage.getItem("token") || "";
      const res = await fetch(`${API_URL}/shops/${CategoryId}/credit-settings`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Accept: "application/json", Authorization: `Bearer ${tkn}` },
        body: JSON.stringify({ credit_limit: parseFloat(editCreditLimit) || 0, credit_terms: editCreditTerms, credit_blocked: editCreditBlocked }),
      });
      const d = await res.json();
      if (d.success) { showMessage(d.message); setCreditData(d.data); setCreditDialogOpen(false); }
      else showErrorMessage(d.message || "Failed");
    } catch { showErrorMessage("Network error"); }
    finally { setSavingCredit(false); }
  };

  const handleBulkPayment = async () => {
    if (!bulkAmount || parseFloat(bulkAmount) <= 0) return;
    setSavingBulkPayment(true);
    try {
      const tkn = localStorage.getItem("token") || "";
      const body: any = { amount: parseFloat(bulkAmount), payment_method: bulkMethod, payment_date: bulkDate, notes: bulkNotes };
      if (selectedInvoiceIds.size > 0) body.invoice_ids = Array.from(selectedInvoiceIds);
      const res = await fetch(`${API_URL}/shop-invoices/shop/${CategoryId}/bulk-payment`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", Authorization: `Bearer ${tkn}` },
        body: JSON.stringify(body),
      });
      const d = await res.json();
      if (d.success) {
        showMessage(d.message || "Payment recorded");
        setBulkPaymentOpen(false); setBulkAmount(""); setBulkNotes(""); setSelectedInvoiceIds(new Set());
        loadInvoices();
      } else { showErrorMessage(d.message || "Failed"); }
    } catch { showErrorMessage("Network error"); }
    finally { setSavingBulkPayment(false); }
  };

  const handleApplyCredit = async () => {
    try {
      const tkn = localStorage.getItem("token") || "";
      const res = await fetch(`${API_URL}/shop-invoices/shop/${CategoryId}/apply-credit`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json", Authorization: `Bearer ${tkn}` },
      });
      const d = await res.json();
      if (d.success) { showMessage(d.message); loadInvoices(); }
      else { showErrorMessage(d.message || "Failed"); }
    } catch { showErrorMessage("Network error"); }
  };

  if (
    isLoading ||
    productBrandLoading ||
    tagLoading ||
    printerLoading ||
    categoryLoading
  ) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error">
        Error fetching category details data. Please try again later.
      </Typography>
    );
  }

const shopOrders: IShopOrder[] = Array.isArray(shopOrdersData?.data) ? (shopOrdersData!.data as IShopOrder[]) : [];

const openOrderForEdit = (order: IShopOrder) => {
  setEditOrderItems(order.items.map(it => ({ ...it })));
  setEditOrderNotes(order.notes || "");
  setViewOrder(order);
};

const handleEditItemQty = (idx: number, val: string) => {
  setEditOrderItems(prev => prev.map((it, i) => i === idx ? { ...it, qty: parseFloat(val) || 0, subtotal: (parseFloat(val) || 0) * it.price } : it));
};

const handleEditItemPrice = (idx: number, val: string) => {
  setEditOrderItems(prev => prev.map((it, i) => i === idx ? { ...it, price: parseFloat(val) || 0, subtotal: it.qty * (parseFloat(val) || 0) } : it));
};

const handleRemoveItem = (idx: number) => {
  setEditOrderItems(prev => prev.filter((_, i) => i !== idx));
};

const editOrderTotal = editOrderItems.reduce((s, it) => s + it.subtotal, 0);

const handleSaveEditedOrder = async (newStatus?: string) => {
  if (!viewOrder || editOrderItems.length === 0) return;
  setSavingOrder(true);
  try {
    const res = await fetch(`${API_URL}/shop-orders/${viewOrder.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      },
      body: JSON.stringify({
        items: editOrderItems,
        total: editOrderTotal,
        notes: editOrderNotes,
        status: newStatus || viewOrder.status,
      }),
    });
    const data = await res.json();
    if (data.success) {
      showMessage(data.message || "Order updated");
      setViewOrder(null);
      refetchOrders();
      loadCreditStatus();
      loadInvoices();
    } else {
      showErrorMessage(data.message || "Failed to update order");
    }
  } catch (e: any) {
    showErrorMessage(e.message);
  } finally {
    setSavingOrder(false);
  }
};

const handlePrintInvoice = () => {
  if (!viewOrder) return;
  const shopName = product?.customerCompanyName || "Restaurant";
  const contactName = [product?.customerFirstName, product?.customerLastName].filter(Boolean).join(" ");
  const shopAddress = [product?.customerStreetNumber, product?.customerStreetName].filter(Boolean).join(" ");
  const shopCity = [product?.customerCity, product?.customerProvince, product?.customerPostalCode].filter(Boolean).join(", ");
  const shopPhone = product?.customerCompanyPhoneNumebr || product?.customerMobileNum || "";
  const shopEmail = product?.customerCompanyEmail || product?.customerEmail || "";
  const invoiceDate = new Date(viewOrder.created_at).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  const invoiceNum = `INV-${String(viewOrder.id).padStart(5, "0")}`;

  const w = window.open("", "_blank", "width=800,height=900");
  if (!w) return;
  w.document.write(`<!DOCTYPE html>
<html><head><title>${invoiceNum}</title>
<style>
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { font-family: 'Segoe UI', Arial, sans-serif; color: #2d2d2d; padding: 0; background: #fff; }
  .invoice { max-width: 800px; margin: 0 auto; padding: 48px 40px; }

  /* Header */
  .header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 40px; padding-bottom: 24px; border-bottom: 3px solid #1a237e; }
  .header-left h1 { font-size: 28px; font-weight: 800; color: #1a237e; letter-spacing: -0.5px; }
  .header-left p { font-size: 12px; color: #888; margin-top: 4px; }
  .header-right { text-align: right; }
  .header-right .inv-num { font-size: 20px; font-weight: 700; color: #1a237e; }
  .header-right .inv-date { font-size: 13px; color: #666; margin-top: 4px; }
  .header-right .inv-status { display: inline-block; margin-top: 8px; padding: 4px 14px; border-radius: 20px; font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; background: #e8f5e9; color: #2e7d32; }

  /* Bill To */
  .bill-section { display: flex; justify-content: space-between; margin-bottom: 32px; }
  .bill-box { flex: 1; }
  .bill-box h3 { font-size: 10px; text-transform: uppercase; letter-spacing: 1px; color: #999; margin-bottom: 8px; font-weight: 700; }
  .bill-box p { font-size: 13px; line-height: 1.7; color: #444; }
  .bill-box .name { font-size: 15px; font-weight: 700; color: #1a237e; }

  /* Table */
  .items-table { width: 100%; border-collapse: collapse; margin-bottom: 24px; }
  .items-table thead th { text-align: left; padding: 12px 8px; font-size: 10px; text-transform: uppercase; letter-spacing: 0.8px; color: #999; font-weight: 700; border-bottom: 2px solid #e0e0e0; }
  .items-table thead th.right { text-align: right; }
  .items-table tbody td { padding: 12px 8px; font-size: 13px; border-bottom: 1px solid #f0f0f0; color: #444; }
  .items-table tbody td.right { text-align: right; }
  .items-table tbody td.product { font-weight: 600; color: #2d2d2d; }
  .items-table tbody tr:last-child td { border-bottom: 2px solid #e0e0e0; }

  /* Totals */
  .totals { display: flex; justify-content: flex-end; margin-bottom: 32px; }
  .totals-box { width: 260px; }
  .totals-row { display: flex; justify-content: space-between; padding: 8px 0; font-size: 13px; color: #666; }
  .totals-row.grand { border-top: 2px solid #1a237e; padding-top: 12px; margin-top: 4px; }
  .totals-row.grand span { font-size: 18px; font-weight: 800; color: #1a237e; }

  /* Notes */
  .notes { padding: 16px 20px; background: #f8f9ff; border-radius: 8px; border-left: 4px solid #1a237e; margin-bottom: 32px; }
  .notes h4 { font-size: 11px; text-transform: uppercase; letter-spacing: 0.8px; color: #1a237e; margin-bottom: 6px; font-weight: 700; }
  .notes p { font-size: 13px; color: #555; line-height: 1.6; }

  /* Footer */
  .footer { text-align: center; padding-top: 24px; border-top: 1px solid #e0e0e0; }
  .footer p { font-size: 11px; color: #bbb; }

  @media print {
    body { padding: 0; }
    .invoice { padding: 24px 20px; }
    .no-print { display: none !important; }
  }
</style></head>
<body>
<div class="invoice">
  <!-- Header -->
  <div class="header">
    <div class="header-left">
      <h1>INVOICE</h1>
      <p>Order confirmation & delivery summary</p>
    </div>
    <div class="header-right">
      <div class="inv-num">${invoiceNum}</div>
      <div class="inv-date">${invoiceDate}</div>
      <div class="inv-status">${viewOrder.status}</div>
    </div>
  </div>

  <!-- Bill To -->
  <div class="bill-section">
    <div class="bill-box">
      <h3>Bill To</h3>
      <p class="name">${shopName}</p>
      ${contactName ? `<p>${contactName}</p>` : ""}
      ${shopAddress ? `<p>${shopAddress}</p>` : ""}
      ${shopCity ? `<p>${shopCity}</p>` : ""}
      ${shopPhone ? `<p>${shopPhone}</p>` : ""}
      ${shopEmail ? `<p>${shopEmail}</p>` : ""}
    </div>
    <div class="bill-box" style="text-align: right;">
      <h3>Order Details</h3>
      <p>Order ID: #${viewOrder.id}</p>
      <p>Date: ${invoiceDate}</p>
      <p>Items: ${editOrderItems.length}</p>
    </div>
  </div>

  <!-- Items Table -->
  <table class="items-table">
    <thead>
      <tr>
        <th style="width:36px">#</th>
        <th>Product</th>
        <th class="right" style="width:70px">Qty</th>
        <th class="right" style="width:60px">Unit</th>
        <th class="right" style="width:90px">Price</th>
        <th class="right" style="width:100px">Subtotal</th>
      </tr>
    </thead>
    <tbody>
      ${editOrderItems.map((it, i) => `
      <tr>
        <td>${i + 1}</td>
        <td class="product">${it.name}</td>
        <td class="right">${it.qty}</td>
        <td class="right">${(it as any).unit || "-"}</td>
        <td class="right">$${it.price.toFixed(2)}</td>
        <td class="right">$${it.subtotal.toFixed(2)}</td>
      </tr>`).join("")}
    </tbody>
  </table>

  <!-- Totals -->
  <div class="totals">
    <div class="totals-box">
      <div class="totals-row">
        <span>Subtotal</span>
        <span>$${editOrderTotal.toFixed(2)}</span>
      </div>
      <div class="totals-row grand">
        <span>Total</span>
        <span>$${editOrderTotal.toFixed(2)}</span>
      </div>
    </div>
  </div>

  ${editOrderNotes ? `
  <div class="notes">
    <h4>Notes</h4>
    <p>${editOrderNotes}</p>
  </div>` : ""}

  <!-- Footer -->
  <div class="footer">
    <p>Thank you for your order</p>
  </div>
</div>

<script>window.onload = function() { window.print(); };</script>
</body></html>`);
  w.document.close();
};

const filteredOrders = orderStatusFilter === "all"
  ? shopOrders
  : shopOrders.filter((o) => o.status === orderStatusFilter);

const ORDER_STATUS_COLOR: Record<string, { bg: string; color: string }> = {
  pending:    { bg: "#fff3e0", color: "#e65100" },
  confirmed:  { bg: "#e3f2fd", color: "#0d47a1" },
  processing: { bg: "#f3e5f5", color: "#6a1b9a" },
  delivered:  { bg: "#e8f5e9", color: "#1b5e20" },
  cancelled:  { bg: "#ffebee", color: "#b71c1c" },
};

const handleSubmitOrder = async () => {
  const items = filteredShopProducts
    .filter((p) => (orderCart[Number(p.id)] || 0) > 0)
    .map((p) => {
      const sp = shopProductMap.get(Number(p.id));
      const price = sp?.custom_price != null ? Number(sp.custom_price) : Number(p.wholesaleprice ?? p.productPrice ?? 0);
      const qty = orderCart[Number(p.id)];
      return { product_id: Number(p.id), name: p.productName, qty, price, subtotal: price * qty };
    });
  if (items.length === 0) return;
  const total = items.reduce((s, i) => s + i.subtotal, 0);
  setSubmittingOrder(true);
  try {
    await createShopOrder({ shopId: Number(CategoryId), items, total, notes: orderNotes,  order_date: orderDate } as any).unwrap();
    showMessage("Order created successfully");
    setOpenOrderModal(false);
    setOrderCart({});
    setOrderNotes("");
    setOrderDate(dayjs().format("YYYY-MM-DD"));
    refetchOrders();
  } catch {
    showErrorMessage("Failed to create order");
  } finally {
    setSubmittingOrder(false);
  }
};

const handleSavePrice = async (productId: string, rawValue: string) => {
  const numeric = rawValue.trim() === "" ? null : parseFloat(rawValue);
  if (numeric !== null && isNaN(numeric)) {
    setEditingPrice(null);
    return;
  }
  setSavingPriceId(productId);
  try {
    await updateShopProductPrice({
      shopId: Number(CategoryId),
      productId: Number(productId),
      custom_price: numeric,
    }).unwrap();
    showMessage("Price saved");
  } catch {
    showErrorMessage("Failed to save price");
  } finally {
    setSavingPriceId(null);
    setEditingPrice(null);
  }
};

const downloadTemplate = async () => {
  try {
    const response = await fetch(`${API_URL}/products/template`, {
       method: "GET",
      headers: {
        "Authorization": `Bearer ${localStorage.getItem("token") || ""}`,
        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      }
    });
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "product_template.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error(err);
  }
};

const handleImport = async (e: React.ChangeEvent<HTMLInputElement>) => {
  if (!e.target.files?.length) return;

  const file = e.target.files[0];
  const formData = new FormData();
  formData.append("file", file);
  formData.append("categoryId", CategoryId || "");

  try {
    setIsImporting(true);

    const res = await fetch(`${API_URL}/products/import`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      },
      body: formData,
    });

    const data = await res.json();
    console.log(data);

    if (!res.ok) {
      showErrorMessage(data.message || "Import failed");
      return;
    }

    // ✅ Case 1: Duplicates found
    if (data.duplicates && data.duplicates.length > 0) {
      const duplicateList = data.duplicates
        .map(
          (d: { row: number; productName: string }) =>
            `Row ${d.row}: ${d.productName}`
        )
        .join("\n");

      showErrorMessage(
        `Imported ${data.inserted} products.\n\nDuplicate products skipped:\n${duplicateList}`
      );
    } 
    // ✅ Case 2: All good
    else {
      showMessage(`Products imported successfully `);
    }

    productRefetch();
  } catch (err) {
    console.error(err);
    showErrorMessage("Import error. Please try again.");
  } finally {
    setIsImporting(false);
    e.target.value = ""; // reset file input
  }
};



const handleSaveOrder = async () => {
  try {
    await reorderProduct({
      categoryId: Number(CategoryId),
      orderedIds: orderedProductIds
    }).unwrap();
    showMessage('Product order updated');
    setShowOrderPopup(false);
  } catch (error) {
    console.error(error);
    showErrorMessage('Failed to update product order');
  }
};

const saveShopProductOrder = async (orderedIds: number[]) => {
  const token = localStorage.getItem("token") || "";
  try {
    const res = await fetch(`${API_URL}/shops/${CategoryId}/update-product`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ product_ids: orderedIds }),
    });
    if (!res.ok) throw new Error();
    showMessage("Order saved");
  } catch {
    showErrorMessage("Failed to save order");
  }
};

const handleDragEnd = (result: any) => {
  if (!result.destination) return;
  const items = Array.from(draggableProducts);
  const [moved] = items.splice(result.source.index, 1);
  items.splice(result.destination.index, 0, moved);
  const newIds = items.map((p) => Number(p.id));
  setDraggableProducts(items);
  setProductIds(newIds); // update immediately so "Done" reflects correct order
  saveShopProductOrder(newIds);
};

const enterLayoutMode = () => {
  // Sort filteredShopProducts by current productIds order
  const ordered = productIds
    .map((id) => filteredShopProducts.find((p) => Number(p.id) === id))
    .filter(Boolean) as IProductPopUP[];
  setDraggableProducts(ordered.length ? ordered : [...filteredShopProducts]);
  setLayoutMode(true);
};




  // ── helpers ──────────────────────────────────────────────────────────────
  const DAY_SHORT: Record<string, string> = {
    Monday: "Mon", Tuesday: "Tue", Wednesday: "Wed",
    Thursday: "Thu", Friday: "Fri", Saturday: "Sat", Sunday: "Sun",
  };
  const ALL_DAYS = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];

  const fmt12 = (t: string) => {
    if (!t) return "";
    const [hStr, mStr] = t.split(":");
    let h = parseInt(hStr, 10);
    const period = h >= 12 ? "PM" : "AM";
    if (h === 0) h = 12; else if (h > 12) h -= 12;
    return `${h}:${mStr || "00"} ${period}`;
  };
  const fmtRange = (r: string) => {
    if (!r) return "";
    const [s, e] = r.split("-");
    return e ? `${fmt12(s)} – ${fmt12(e)}` : fmt12(s);
  };

  const activeTab = selectedCard === "Route" ? 1 : selectedCard === "Orders" ? 2 : selectedCard === "Invoices" ? 3 : 0;
  // const portalUrl = `${window.location.origin}${window.location.pathname.split('/shop-history')[0]}/restaurant-portal/${CategoryId}`;
  const portalUrl = `${window.location.origin}${window.location.pathname.split('/shop-history')[0]}/restaurant-portal`;
  const displayedProducts = filteredShopProducts.filter((p) =>
    p.productName.toLowerCase().includes(searchQueryStock.toLowerCase())
  );

  const contactName = [product?.customerFirstName, product?.customerLastName]
    .filter(Boolean).join(" ");
  const addressLine = [
    product?.customerStreetNumber,
    product?.customerStreetName,
  ].filter(Boolean).join(" ");
  const cityLine = [
    product?.customerCity,
    product?.customerProvince,
    product?.customerPostalCode,
  ].filter(Boolean).join(", ");

  return (
    <Box sx={{ background: "linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)", minHeight: "100vh" }}>

      {/* ── HERO HEADER ───────────────────────────────────────────────── */}
      <Card sx={{ borderRadius: 0, mb: 2.5, overflow: "visible", boxShadow: "none" }}>
        <Box
          sx={{
            background: "linear-gradient(90deg, #0f172a 0%, #1e3a8a 100%)",
            borderBottom: "1px solid rgba(255,255,255,0.08)",
            px: { xs: 2, md: 4 },
            py: 3,
          }}
        >
          {/* Top row: Back + Edit buttons */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mb: 2 }}>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIosNewIcon sx={{ fontSize: 14 }} />}
              onClick={() => navigate(-1)}
              sx={{
                color: "#e2e8f0",
                borderColor: "rgba(255,255,255,0.35)",
                borderRadius: "10px",
                fontSize: 12,
                fontWeight: 600,
                textTransform: "none",
                transition: "all 0.18s ease",
                "&:hover": { borderColor: "#fff", bgcolor: "rgba(255,255,255,0.08)", transform: "translateY(-1px)" },
              }}
            >
              Back
            </Button>
            <Button
              variant="contained"
              disableElevation
              startIcon={<ModeEditIcon sx={{ fontSize: 14 }} />}
              onClick={() => navigate(`/shop/edit/${id}`)}
              sx={{
                bgcolor: "#1e293b",
                color: "#fff",
                borderRadius: "10px",
                fontSize: 12,
                fontWeight: 600,
                textTransform: "none",
                transition: "all 0.18s ease",
                "&:hover": { bgcolor: "#334155", transform: "translateY(-1px)" },
              }}
            >
              Edit
            </Button>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 2.5, flexWrap: "wrap" }}>
            {/* Avatar */}
            <Box
              sx={{
                width: 72, height: 72, borderRadius: "14px",
                border: "1px solid rgba(255,255,255,0.2)",
                overflow: "hidden", flexShrink: 0,
                bgcolor: "rgba(255,255,255,0.15)",
                display: "flex", alignItems: "center", justifyContent: "center",
              }}
            >
              {product?.customerImg ? (
                <img
                  src={`${LARAVEL_API_URL}/${product.customerImg}`}
                  alt="shop"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                <Typography sx={{ fontSize: 22, fontWeight: 700, color: "#fff" }}>
                  {(product?.customerCompanyName || product?.customerFirstName || "S")
                    .charAt(0).toUpperCase()}
                </Typography>
              )}
            </Box>

            {/* Name + contact */}
            <Box sx={{ flex: 1, minWidth: 200 }}>
              <Typography sx={{ fontSize: 22, fontWeight: 700, color: "#ffffff", lineHeight: 1.2 }}>
                {product?.customerCompanyName || contactName || "—"}
              </Typography>
              {product?.customerCompanyName && contactName && (
                <Typography sx={{ fontSize: 13, color: "#cbd5f5", mt: 0.25 }}>
                  {contactName}
                </Typography>
              )}
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 1 }}>
                {product?.customerMobileNum && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, color: "#cbd5f5" }}>
                    <PhoneIcon sx={{ fontSize: 15 }} />
                    <Typography sx={{ fontSize: 13 }}>{product.customerMobileNum}</Typography>
                  </Box>
                )}
                {product?.customerEmail && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, color: "#cbd5f5" }}>
                    <EmailIcon sx={{ fontSize: 15 }} />
                    <Typography sx={{ fontSize: 13 }}>{product.customerEmail}</Typography>
                  </Box>
                )}
              </Box>
            </Box>

            {/* Address block */}
            {(addressLine || cityLine) && (
              <Box
                sx={{
                  ml: "auto",
                  textAlign: "right",
                  bgcolor: "rgba(255,255,255,0.08)",
                  backdropFilter: "blur(6px)",
                  borderRadius: "12px",
                  px: "14px", py: "10px",
                  border: "1px solid rgba(255,255,255,0.15)",
                  color: "#e2e8f0",
                  minWidth: 180,
                }}
              >
                {addressLine && (
                  <Typography sx={{ fontSize: 13, color: "#e2e8f0", fontWeight: 500 }}>
                    {addressLine}
                  </Typography>
                )}
                {cityLine && (
                  <Typography sx={{ fontSize: 12, color: "#cbd5f5" }}>
                    {cityLine}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        </Box>

        {/* Stats bar */}
        <Box
          sx={{
            display: "flex", alignItems: "center", gap: 3,
            px: 4, py: 1.25, bgcolor: "#fff", borderTop: "1px solid #e8eaf6",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
            <Inventory2Icon sx={{ fontSize: 16, color: "#5c6bc0" }} />
            <Typography fontSize={12} color="text.secondary">
              <strong style={{ color: "#3949ab" }}>{filteredShopProducts.length}</strong> Products assigned
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
            <DirectionsIcon sx={{ fontSize: 16, color: "#7986cb" }} />
            <Typography fontSize={12} color="text.secondary">
              <strong style={{ color: "#3949ab" }}>{routesArray.length}</strong> Routes assigned
            </Typography>
          </Box>
          {product?.customerDescription && (
            <Tooltip title={<span dangerouslySetInnerHTML={{ __html: product.customerDescription }} />}>
              <Chip label="Has notes" size="small" sx={{ fontSize: 11, height: 20, bgcolor: "#e8eaf6", color: "#3949ab" }} />
            </Tooltip>
          )}
          <Box sx={{ ml: "auto" }}>
            <Button
              size="small" variant="outlined"
              onClick={() => {
  setPortalEmail(
    (product as any)?.portal_email
      || product?.customerCompanyEmail
      || product?.customerEmail
      || ""
  );
  setPortalPassword("");
  setPortalSetupMsg("");
  setOpenPortalSetup(true);
}}
              sx={{ fontSize: 11, fontWeight: 600, textTransform: "none", borderRadius: "8px", borderColor: "#c5cae9", color: "#3949ab", "&:hover": { borderColor: "#3949ab" } }}
            >
              Portal Access
            </Button>
          </Box>
        </Box>
      </Card>

      {/* ── PORTAL ACCESS CARD ───────────────────────────────────────── */}
      <Box sx={{ px: { xs: 1.5, md: 2.5 }, mb: 2 }}>
        <Card sx={{ borderRadius: "12px", border: "1px solid #e5e7eb", boxShadow: "0 2px 8px rgba(15,23,42,0.05)" }}>
          <Box sx={{ p: 2.25 }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1.5, mb: 1.5 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                <Box sx={{ width: 32, height: 32, borderRadius: "8px", bgcolor: "#eef2ff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <LinkIcon sx={{ fontSize: 18, color: "#3949ab" }} />
                </Box>
                <Box>
                  <Typography fontSize={14} fontWeight={700} color="#0f172a">Portal Access</Typography>
                  <Typography fontSize={11} color="#64748b">Restaurant self-service login</Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {(() => {
                  const setup = !!portalStatus?.has_password;
                  const active = !!portalStatus?.is_active;
                  const label = !setup ? "Not Setup" : active ? "Active" : "Disabled";
                  const color = !setup ? { bg: "#f1f5f9", fg: "#64748b" } : active ? { bg: "#dcfce7", fg: "#166534" } : { bg: "#fee2e2", fg: "#991b1b" };
                  return (
                    <Chip size="small" label={label} sx={{ fontSize: 11, fontWeight: 700, height: 22, borderRadius: "999px", bgcolor: color.bg, color: color.fg }} />
                  );
                })()}
              </Box>
            </Box>

            <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
              <Grid item xs={12} md={6}>
                <Typography fontSize={11} fontWeight={700} color="#64748b" textTransform="uppercase" letterSpacing={0.5} mb={0.5}>Portal Link</Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, p: 1, bgcolor: "#f8fafc", borderRadius: "8px", border: "1px solid #e5e7eb" }}>
                  <Typography fontSize={12} sx={{ flex: 1, color: "#334155", wordBreak: "break-all", fontFamily: "monospace" }}>{portalUrl}</Typography>
                  <Tooltip title="Copy link">
                    <IconButton size="small" onClick={handleCopyPortalLink} sx={{ width: 28, height: 28, color: "#3949ab", "&:hover": { bgcolor: "#eef2ff" } }}>
                      <ContentCopyIcon sx={{ fontSize: 15 }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Open in new tab">
                    <IconButton size="small" onClick={() => window.open(portalUrl, "_blank")} sx={{ width: 28, height: 28, color: "#3949ab", "&:hover": { bgcolor: "#eef2ff" } }}>
                      <OpenInNewIcon sx={{ fontSize: 15 }} />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography fontSize={11} fontWeight={700} color="#64748b" textTransform="uppercase" letterSpacing={0.5} mb={0.5}>Email</Typography>
                <Typography fontSize={12} sx={{ p: 1, bgcolor: "#f8fafc", borderRadius: "8px", border: "1px solid #e5e7eb", color: portalStatus?.portal_email ? "#334155" : "#94a3b8", minHeight: 32, display: "flex", alignItems: "center" }}>
                  {portalStatus?.portal_email || "Not set"}
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography fontSize={11} fontWeight={700} color="#64748b" textTransform="uppercase" letterSpacing={0.5} mb={0.5}>Password</Typography>
                <Typography fontSize={12} sx={{ p: 1, bgcolor: "#f8fafc", borderRadius: "8px", border: "1px solid #e5e7eb", color: portalStatus?.has_password ? "#334155" : "#94a3b8", minHeight: 32, display: "flex", alignItems: "center", fontFamily: portalStatus?.has_password ? "monospace" : undefined, letterSpacing: portalStatus?.has_password ? 2 : 0 }}>
                  {portalStatus?.has_password ? "••••••••" : "Not set"}
                </Typography>
              </Grid>
            </Grid>

            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
              <Button size="small" variant="contained" disableElevation startIcon={<VpnKeyIcon sx={{ fontSize: 14 }} />}
                onClick={() => {
                  setPortalEmail(portalStatus?.portal_email || (product as any)?.customerCompanyEmail || product?.customerEmail || "");
                  setPortalPassword("");
                  setPortalSetupMsg("");
                  setOpenPortalSetup(true);
                }}
                sx={{ fontSize: 11, fontWeight: 600, textTransform: "none", borderRadius: "8px", bgcolor: "#3949ab", "&:hover": { bgcolor: "#1a237e" } }}>
                {portalStatus?.has_password ? "Update Credentials" : "Set Credentials"}
              </Button>
              <Button size="small" variant="outlined" startIcon={<RestartAltIcon sx={{ fontSize: 14 }} />}
                onClick={() => {
                  if (!portalStatus?.portal_email) { showErrorMessage("Set a portal email first."); return; }
                  setResetPwdDialogOpen(true);
                }}
                disabled={portalBusy || !portalStatus?.portal_email}
                sx={{ fontSize: 11, fontWeight: 600, textTransform: "none", borderRadius: "8px", borderColor: "#c5cae9", color: "#3949ab", "&:hover": { borderColor: "#3949ab", bgcolor: "#eef2ff" } }}>
                Reset Password
              </Button>
              {portalStatus?.has_password && (
                <Button size="small" variant="outlined"
                  startIcon={portalStatus.is_active ? <BlockIcon sx={{ fontSize: 14 }} /> : <CheckCircleIcon sx={{ fontSize: 14 }} />}
                  onClick={handleTogglePortalActive}
                  disabled={portalBusy}
                  sx={{
                    fontSize: 11, fontWeight: 600, textTransform: "none", borderRadius: "8px",
                    borderColor: portalStatus.is_active ? "#fecaca" : "#bbf7d0",
                    color: portalStatus.is_active ? "#b91c1c" : "#15803d",
                    "&:hover": { borderColor: portalStatus.is_active ? "#dc2626" : "#16a34a", bgcolor: portalStatus.is_active ? "#fef2f2" : "#f0fdf4" },
                  }}>
                  {portalStatus.is_active ? "Disable Access" : "Enable Access"}
                </Button>
              )}
            </Box>
          </Box>
        </Card>
      </Box>

      {/* ── CREDIT SUMMARY ───────────────────────────────────────────── */}
      {creditData && (
        <Box sx={{ px: { xs: 1.5, md: 2.5 }, mb: 2 }}>
          {/* Warning alerts */}
          {creditData.has_overdue && (
            <Alert severity="error" sx={{ mb: 1.5, borderRadius: 2, fontSize: 13 }}>
              <strong>{creditData.overdue_count} overdue invoice{creditData.overdue_count !== 1 ? "s" : ""}</strong> totaling ${creditData.overdue_amount?.toFixed(2)}. Ordering is blocked until resolved.
            </Alert>
          )}
          {!creditData.has_overdue && creditData.is_blocked && !creditData.manually_blocked && (
            <Alert severity="warning" sx={{ mb: 1.5, borderRadius: 2, fontSize: 13 }}>
              Credit limit exceeded (${creditData.outstanding.toFixed(2)} / ${creditData.credit_limit.toFixed(2)}). Restaurant cannot place new orders.
            </Alert>
          )}
          {creditData.manually_blocked && !creditData.has_overdue && (
            <Alert severity="error" sx={{ mb: 1.5, borderRadius: 2, fontSize: 13 }}>
              Orders are <strong>manually blocked</strong> for this restaurant.
            </Alert>
          )}
          {!creditData.is_blocked && creditData.color === "orange" && (
            <Alert severity="warning" sx={{ mb: 1.5, borderRadius: 2, fontSize: 13 }}>
              Credit usage at <strong>{creditData.usage_percent}%</strong> — approaching limit. Available: <strong>${creditData.available?.toFixed(2)}</strong>
            </Alert>
          )}

          <Card sx={{ borderRadius: "16px", overflow: "hidden", bgcolor: "#ffffff", border: "1px solid #e2e8f0", boxShadow: "none", p: 0 }}>
            {/* Header */}
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2.5, py: 1.5, borderBottom: "1px solid #f1f5f9" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <Typography fontWeight={700} fontSize={14} color="#0f172a">Credit & Payments</Typography>
                <Chip
                  label={creditData.color === "red" ? "Over Limit" : creditData.color === "orange" ? "Near Limit" : "Good Standing"}
                  size="small"
                  sx={{ fontSize: 11, fontWeight: 600, height: 22, borderRadius: "999px",
                    bgcolor: creditData.color === "red" ? "#fee2e2" : creditData.color === "orange" ? "#fef3c7" : "#dcfce7",
                    color: creditData.color === "red" ? "#991b1b" : creditData.color === "orange" ? "#92400e" : "#166534" }}
                />
              </Box>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button size="small" variant="contained" onClick={() => { setSelectedCard("Invoices"); setBulkPaymentOpen(true); }}
                  sx={{ fontSize: 11, fontWeight: 600, textTransform: "none", borderRadius: "8px", bgcolor: "#009688", "&:hover": { bgcolor: "#00796B" } }}>
                  Record Payment
                </Button>
                <Button size="small" variant="outlined"
                  onClick={() => { setEditCreditLimit(String(creditData.credit_limit || 0)); setEditCreditTerms(creditData.credit_terms || "no_limit"); setEditCreditBlocked(creditData.manually_blocked || false); setCreditDialogOpen(true); }}
                  sx={{ fontSize: 11, fontWeight: 600, textTransform: "none", borderRadius: "8px", borderColor: "#c5cae9", color: "#3949ab", "&:hover": { borderColor: "#3949ab" } }}>
                  Settings
                </Button>
              </Box>
            </Box>

            {/* Main cards row */}
            <Box sx={{ display: "flex", gap: 1.5, px: 2.5, py: 2, flexWrap: "wrap", alignItems: "stretch" }}>
              {[
                { label: "Credit Limit", value: creditData.credit_limit > 0 ? `$${creditData.credit_limit.toFixed(2)}` : "No Limit", color: "#1565C0" },
                { label: "Outstanding", value: `$${creditData.outstanding.toFixed(2)}`, color: creditData.outstanding > 0 ? "#E65100" : "#2E7D32" },
                { label: "Available", value: creditData.available !== null ? `$${creditData.available.toFixed(2)}` : "Unlimited", color: creditData.color === "red" ? "#C62828" : creditData.color === "orange" ? "#E65100" : "#2E7D32" },
                { label: "Credit Balance", value: `$${creditData.credit_balance.toFixed(2)}`, color: creditData.credit_balance > 0 ? "#2E7D32" : "#999" },
              ].map(c => (
                <Paper key={c.label} elevation={0} sx={{ px: "14px", py: "14px", borderRadius: "12px", border: "1px solid #e5e7eb", bgcolor: "#f8fafc", flex: 1, minWidth: 110 }}>
                  <Typography fontSize={10} color="#64748b" fontWeight={600} textTransform="uppercase" letterSpacing={0.5}>{c.label}</Typography>
                  <Typography fontSize={18} fontWeight={700} color="#0f172a" mt={0.5}>{c.value}</Typography>
                </Paper>
              ))}

              {/* Status + Progress */}
              <Paper elevation={0} sx={{ px: "14px", py: "14px", borderRadius: "12px", border: "1px solid #e5e7eb", bgcolor: "#f8fafc", minWidth: 170, flex: 1 }}>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 0.25 }}>
                  <Typography fontSize={10} color="#999" fontWeight={600} textTransform="uppercase" letterSpacing={0.3}>Usage</Typography>
                  <Typography fontSize={10} color="#999">
                    {creditData.credit_terms === "no_limit" ? "No terms" : creditData.credit_terms.replace("_", " ").toUpperCase()}
                  </Typography>
                </Box>
                {creditData.credit_limit > 0 ? (
                  <>
                    <Box sx={{ height: 8, bgcolor: "#f0f0f0", borderRadius: 4, overflow: "hidden", mb: 0.25 }}>
                      <Box sx={{
                        height: "100%", width: `${Math.min(100, creditData.usage_percent)}%`,
                        bgcolor: creditData.color === "red" ? "#C62828" : creditData.color === "orange" ? "#E65100" : "#2E7D32",
                        borderRadius: 4, transition: "width 0.3s",
                      }} />
                    </Box>
                    <Typography fontSize={11} fontWeight={700} color={creditData.color === "red" ? "#C62828" : creditData.color === "orange" ? "#E65100" : "#2E7D32"}>
                      {creditData.usage_percent}%
                    </Typography>
                  </>
                ) : (
                  <Typography fontSize={12} fontWeight={600} color="#2E7D32" mt={0.5}>Unlimited</Typography>
                )}
              </Paper>
            </Box>

            {/* Bottom row: Invoice counts + Last payment */}
            <Box sx={{ display: "flex", gap: 2, px: 2.5, pb: 2, flexWrap: "wrap", alignItems: "center" }}>
              {/* Invoice mini summary */}
              {creditData.invoice_counts && (
                <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                  {[
                    { label: "Total", count: creditData.invoice_counts.total, color: "#666" },
                    { label: "Unpaid", count: creditData.invoice_counts.unpaid, color: "#E65100" },
                    { label: "Partial", count: creditData.invoice_counts.partial, color: "#1565C0" },
                    { label: "Paid", count: creditData.invoice_counts.paid, color: "#2E7D32" },
                  ].map(s => (
                    <Box key={s.label} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      <Box sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: s.color }} />
                      <Typography fontSize={11} color="#999">{s.label}: <strong style={{ color: s.color }}>{s.count}</strong></Typography>
                    </Box>
                  ))}
                </Box>
              )}

              {/* Spacer */}
              <Box sx={{ flex: 1 }} />

              {/* Last payment */}
              {creditData.last_payment && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, px: 1.5, py: 0.5, bgcolor: "#F1F8E9", borderRadius: 1.5 }}>
                  <Typography fontSize={10} color="#558B2F" fontWeight={600}>Last Payment:</Typography>
                  <Typography fontSize={11} fontWeight={700} color="#2E7D32">${creditData.last_payment.amount.toFixed(2)}</Typography>
                  <Typography fontSize={10} color="#7CB342">{creditData.last_payment.method} &middot; {dayjs(creditData.last_payment.date).format("MMM D")}</Typography>
                </Box>
              )}
            </Box>
          </Card>
        </Box>
      )}

      {/* ── TABS + CONTENT ────────────────────────────────────────────── */}
      <Box sx={{ px: { xs: 1.5, md: 2.5 } }}>
        <Card sx={{ borderRadius: "16px", overflow: "hidden", bgcolor: "#ffffff", border: "1px solid #e2e8f0", boxShadow: "none" }}>
          <Tabs
            value={activeTab}
            onChange={(_, v) => setSelectedCard(v === 0 ? "Product" : v === 1 ? "Route" : v === 2 ? "Orders" : "Invoices")}
            sx={{
              borderBottom: "1px solid #e5e7eb",
              "& .MuiTabs-flexContainer": { gap: "20px", px: 2 },
              "& .MuiTab-root": {
                fontSize: 13,
                fontWeight: 500,
                textTransform: "none",
                minHeight: 48,
                color: "#64748b",
                px: 0,
                minWidth: 0,
              },
              "& .MuiTab-root.Mui-selected": { color: "#1e293b", fontWeight: 600 },
              "& .MuiTabs-indicator": { height: 3, borderRadius: "3px 3px 0 0", bgcolor: "#1e293b" },
            }}
          >
            <Tab label={`Products (${filteredShopProducts.length})`} />
            <Tab label={`Routes (${routesArray.length})`} />
            <Tab label={`Orders (${shopOrders.length})`} />
            <Tab label={`Invoices${invoiceSummary ? ` (${invoiceSummary.invoice_count})` : ""}`} />
          </Tabs>

          {/* ── PRODUCTS TAB ─────────────────────────────────────────── */}
          {activeTab === 0 && (
            <Box>
              {/* Toolbar */}
              <Box
                sx={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  px: 2.5, py: 1.75, borderBottom: "1px solid #f0f0f5",
                }}
              >
                <TextField
                  size="small"
                  placeholder="Search products..."
                  value={searchQueryStock}
                  onChange={(e) => setSearchQueryStock(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <CiSearch className={classes.searchWidgetIcon} />
                      </InputAdornment>
                    ),
                    classes: { root: classes.formControlList },
                  }}
                  sx={{ width: 260 }}
                />
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Button
                    variant={layoutMode ? "contained" : "outlined"}
                    onClick={() => layoutMode ? setLayoutMode(false) : enterLayoutMode()}
                    startIcon={<DragIndicatorIcon sx={{ fontSize: 16 }} />}
                    sx={{
                      fontSize: 12, fontWeight: 600, textTransform: "none",
                      borderRadius: "8px", px: 1.5,
                      ...(layoutMode
                        ? { bgcolor: "#ff9800", borderColor: "#ff9800", "&:hover": { bgcolor: "#f57c00" } }
                        : { borderColor: "#bdbdbd", color: "#555", "&:hover": { borderColor: "#ff9800", color: "#ff9800" } }),
                    }}
                  >
                    {layoutMode ? "Done" : "Layout"}
                  </Button>
                  <Button
                    variant="contained"
                    className={classes.addButton}
                    onClick={handleOpen}
                    startIcon={<span style={{ fontSize: 18, lineHeight: 1 }}>+</span>}
                  >
                    Add Product
                  </Button>
                </Box>
              </Box>

              {/* Product Table */}
              <TableContainer>
                <Table className={classes.table}>
                  <TableHead className={classes.tableHeaderRow}>
                    <TableRow>
                      <TableCell className={classes.tablheader}><strong>#</strong></TableCell>
                      <TableCell className={classes.tablheader}><strong>Product</strong></TableCell>
                      <TableCell className={classes.tablheader}><strong>In-Store Price</strong></TableCell>
                      <TableCell className={classes.tablheader}><strong>Wholesale Price</strong></TableCell>
                      <TableCell className={classes.tablheader}>
                        <strong>Custom Price</strong>
                        <Typography component="span" sx={{ fontSize: 10, color: "rgba(255,255,255,0.65)", ml: 0.5 }}>
                          (click to edit)
                        </Typography>
                      </TableCell>
                      <TableCell className={classes.tablheader} sx={{ textAlign: "right" }}><strong>Actions</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  {/* shared row cells — used in both normal and drag mode */}
                  {(() => {
                    const renderCells = (row: IProductPopUP, index: number) => (
                      <>
                        <TableCell className={classes.tablCell} sx={{ width: 36, pl: 1 }}>
                          {layoutMode ? (
                            <DragIndicatorIcon sx={{ fontSize: 18, color: "#bdbdbd", cursor: "grab", verticalAlign: "middle" }} />
                          ) : (
                            index + 1
                          )}
                        </TableCell>
                        <TableCell className={classes.tablCell}>
                          <Link to={`/product-history/${row.id}`} style={{ textDecoration: "none", color: "inherit" }}>
                            <Typography fontWeight={500} fontSize={13} sx={{ "&:hover": { color: "#3949ab" } }}>
                              {row.productName?.charAt(0).toUpperCase() + row.productName?.slice(1).toLowerCase()}
                            </Typography>
                          </Link>
                          {row.productShortDescription && (
                            <Typography fontSize={11} color="text.secondary" noWrap sx={{ maxWidth: 320 }}>
                              {String(row.productShortDescription).replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim()}
                            </Typography>
                          )}
                        </TableCell>
                        <TableCell className={classes.tablCell}>
                          <Typography fontSize={13} fontWeight={600} color="#2e7d32">
                            {row.salePrice ? `$${Number(row.salePrice).toFixed(2)}` : "—"}
                          </Typography>
                        </TableCell>
                        <TableCell className={classes.tablCell}>
                          <Typography fontSize={13} fontWeight={600} color="#1565c0">
                            {row.wholesaleprice ? `$${Number(row.wholesaleprice).toFixed(2)}` : "—"}
                          </Typography>
                        </TableCell>
                        <TableCell className={classes.tablCell}>
                          {!layoutMode && (editingPrice?.productId === row.id ? (
                            <TextField
                              autoFocus size="small" type="number"
                              value={editingPrice.value}
                              onChange={(e) => setEditingPrice({ productId: row.id, value: e.target.value })}
                              onBlur={() => handleSavePrice(row.id, editingPrice.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") handleSavePrice(row.id, editingPrice.value);
                                if (e.key === "Escape") setEditingPrice(null);
                              }}
                              inputProps={{ step: "0.01", min: "0", style: { fontSize: 13, padding: "4px 8px", width: 90 } }}
                              sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" }, "& .MuiOutlinedInput-notchedOutline": { borderColor: "#e65100" } }}
                            />
                          ) : (
                            <Box
                              onClick={() => {
                                const sp = shopProductMap.get(Number(row.id));
                                setEditingPrice({ productId: row.id, value: sp?.custom_price != null ? String(sp.custom_price) : row.wholesaleprice ?? "" });
                              }}
                              sx={{ display: "inline-flex", alignItems: "center", gap: 0.75, cursor: "pointer", borderRadius: "8px", px: 1, py: 0.5, border: "1px dashed transparent", "&:hover": { border: "1px dashed #ffb74d", bgcolor: "#fff3e0" } }}
                            >
                              {savingPriceId === row.id ? <CircularProgress size={14} /> : (() => {
                                const sp = shopProductMap.get(Number(row.id));
                                const isCustom = sp?.custom_price != null;
                                const val = isCustom ? sp!.custom_price : row.wholesaleprice;
                                return (
                                  <>
                                    <Typography fontSize={13} fontWeight={600} color={isCustom ? "#e65100" : "#1565c0"}>
                                      {val ? `$${Number(val).toFixed(2)}` : "—"}
                                    </Typography>
                                    <EditSharpIcon sx={{ fontSize: 12, color: "#ffb74d", opacity: 0.8 }} />
                                  </>
                                );
                              })()}
                            </Box>
                          ))}
                          {layoutMode && (
                            <Typography fontSize={12} color="text.disabled" fontStyle="italic">—</Typography>
                          )}
                        </TableCell>
                        <TableCell className={classes.tablCell} sx={{ textAlign: "right" }}>
                          {!layoutMode && (
                            <Button variant="contained" size="small" onClick={() => handleDeleteProduct(Number(row.id))}
                              sx={{ minWidth: 32, width: 32, height: 32, p: 0, borderRadius: "8px", background: "linear-gradient(135deg, #e53935 0%, #ef5350 100%)", boxShadow: "none", "&:hover": { background: "linear-gradient(135deg, #c62828 0%, #e53935 100%)", boxShadow: "none" } }}>
                              <DeleteOutlineSharpIcon sx={{ fontSize: 15 }} />
                            </Button>
                          )}
                        </TableCell>
                      </>
                    );

                    if (displayedProducts.length === 0 && !layoutMode) {
                      return (
                        <TableBody>
                          <TableRow>
                            <TableCell colSpan={6} align="center" sx={{ py: 6 }}>
                              <Inventory2Icon sx={{ fontSize: 40, color: "#c5cae9", mb: 1, display: "block", mx: "auto" }} />
                              <Typography fontSize={14} color="text.secondary">
                                {searchQueryStock ? "No matching products" : "No products assigned yet"}
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      );
                    }

                    if (layoutMode) {
                      return (
                        <DragDropContext onDragEnd={handleDragEnd}>
                          <Droppable droppableId="shop-products">
                            {(provided) => (
                              <TableBody ref={provided.innerRef} {...provided.droppableProps}>
                                {draggableProducts.map((row, index) => (
                                  <Draggable key={String(row.id)} draggableId={String(row.id)} index={index}>
                                    {(provided, snapshot) => (
                                      <TableRow
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        sx={{
                                          bgcolor: snapshot.isDragging ? "#fff8e1" : "inherit",
                                          boxShadow: snapshot.isDragging ? "0 4px 16px rgba(0,0,0,0.15)" : "none",
                                          display: snapshot.isDragging ? "table" : undefined,
                                        }}
                                      >
                                        {renderCells(row, index)}
                                      </TableRow>
                                    )}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </TableBody>
                            )}
                          </Droppable>
                        </DragDropContext>
                      );
                    }

                    return (
                      <TableBody>
                        {displayedProducts
                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((row, index) => (
                            <TableRow key={row.id} className={classes.tableRowHover}>
                              {renderCells(row, page * rowsPerPage + index)}
                            </TableRow>
                          ))}
                      </TableBody>
                    );
                  })()}

                </Table>
              </TableContainer>
              {displayedProducts.length > rowsPerPage && (
                <Box sx={{ px: 2, py: 2, display: "flex", justifyContent: "flex-end" }}>
                  <Pagination
                    count={displayedProducts.length}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={handleChangePage}
                  />
                </Box>
              )}
            </Box>
          )}

          {/* ── ROUTES TAB ───────────────────────────────────────────── */}
          {activeTab === 1 && (
            <Box>
              {/* Toolbar */}
              <Box
                sx={{
                  display: "flex", alignItems: "center", justifyContent: "space-between",
                  px: 2.5, py: 1.75, borderBottom: "1px solid #f0f0f5",
                }}
              >
                <Typography fontSize={13} color="text.secondary">
                  {routesArray.length} route{routesArray.length !== 1 ? "s" : ""} assigned to this restaurant
                </Typography>
                <Button
                  variant="contained"
                  className={classes.addButton}
                  onClick={() => setOpenRouteModal(true)}
                  startIcon={<span style={{ fontSize: 18, lineHeight: 1 }}>+</span>}
                >
                  Add Route
                </Button>
              </Box>

              {/* Route cards */}
              <Box sx={{ p: 2.5 }}>
                {routesArray.length === 0 ? (
                  <Box
                    textAlign="center" py={7}
                    sx={{ background: "#f8f9ff", borderRadius: "12px", border: "2px dashed #c5cae9" }}
                  >
                    <DirectionsIcon sx={{ fontSize: 44, color: "#c5cae9", mb: 1 }} />
                    <Typography fontSize={14} color="text.secondary" fontWeight={500}>No routes assigned</Typography>
                    <Typography fontSize={12} color="text.disabled" mb={2}>Assign a delivery route to this restaurant</Typography>
                    <Button variant="contained" className={classes.addButton} onClick={() => setOpenRouteModal(true)}>
                      Add Route
                    </Button>
                  </Box>
                ) : (
                  <Grid container spacing={2}>
                    {routesArray.map((route: IRoutes) => {
                      const activeDays = ALL_DAYS.filter(
                        (d) => route.delivery_schedule?.[d as keyof typeof route.delivery_schedule]
                      );
                      const isWeekend = (d: string) => d === "Saturday" || d === "Sunday";
                      const cities: string[] = Array.isArray(route.cities)
                        ? route.cities
                        : (() => { try { return JSON.parse(route.cities as any); } catch { return []; } })();

                      return (
                        <Grid item xs={12} md={6} key={route.id}>
                          <Box
                            sx={{
                              border: "1px solid #e8eaf0", borderRadius: "12px", p: 2,
                              transition: "box-shadow 0.2s",
                              "&:hover": { boxShadow: "0 4px 16px rgba(0,0,0,0.08)" },
                            }}
                          >
                            <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", mb: 1 }}>
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                                <Box
                                  sx={{
                                    width: 36, height: 36, borderRadius: "9px", flexShrink: 0,
                                    background: "linear-gradient(135deg, #3f51b5 0%, #5c6bc0 100%)",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                  }}
                                >
                                  <DirectionsIcon sx={{ color: "#fff", fontSize: 18 }} />
                                </Box>
                                <Box>
                                  <Typography fontWeight={700} fontSize={14}>{route.name}</Typography>
                                  <Typography fontSize={11} color="text.secondary">
                                    {activeDays.length > 0
                                      ? `${activeDays.length} delivery day${activeDays.length > 1 ? "s" : ""}`
                                      : "No schedule"}
                                  </Typography>
                                </Box>
                              </Box>
                              <Button
                                variant="contained"
                                size="small"
                                onClick={() => handleDeleteRoute(route.id)}
                                sx={{
                                  minWidth: 30, width: 30, height: 30, p: 0, borderRadius: "8px",
                                  background: "linear-gradient(135deg, #e53935 0%, #ef5350 100%)",
                                  boxShadow: "none",
                                  "&:hover": { background: "linear-gradient(135deg, #c62828 0%, #e53935 100%)", boxShadow: "none" },
                                }}
                              >
                                <DeleteOutlineSharpIcon sx={{ fontSize: 14 }} />
                              </Button>
                            </Box>

                            {cities.length > 0 && (
                              <Box sx={{ mb: 1 }}>
                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                  {cities.slice(0, 5).map((city) => (
                                    <Chip key={city} label={city} size="small"
                                      sx={{ height: 20, fontSize: 10, bgcolor: "#e8eaf6", color: "#3949ab", "& .MuiChip-label": { px: 0.75 } }}
                                    />
                                  ))}
                                  {cities.length > 5 && (
                                    <Chip label={`+${cities.length - 5}`} size="small"
                                      sx={{ height: 20, fontSize: 10, bgcolor: "#f3f3f3", color: "#777", "& .MuiChip-label": { px: 0.75 } }}
                                    />
                                  )}
                                </Box>
                              </Box>
                            )}

                            {activeDays.length > 0 && (
                              <>
                                <Divider sx={{ my: 1, borderColor: "#f0f0f5" }} />
                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                  {activeDays.map((day) => {
                                    const range = route.delivery_schedule?.[day as keyof typeof route.delivery_schedule] || "";
                                    return (
                                      <Box
                                        key={day}
                                        sx={{
                                          display: "flex", alignItems: "center", gap: 0.5,
                                          bgcolor: isWeekend(day) ? "#fff3e0" : "#e3f2fd",
                                          border: `1px solid ${isWeekend(day) ? "#ffcc80" : "#90caf9"}`,
                                          borderRadius: "7px", px: 1, py: 0.4,
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            width: 26, height: 16, borderRadius: "3px",
                                            bgcolor: isWeekend(day) ? "#ff9800" : "#1976d2",
                                            display: "flex", alignItems: "center", justifyContent: "center",
                                          }}
                                        >
                                          <Typography sx={{ fontSize: 8, fontWeight: 700, color: "#fff", lineHeight: 1 }}>
                                            {DAY_SHORT[day]}
                                          </Typography>
                                        </Box>
                                        {range && (
                                          <Typography sx={{ fontSize: 10, fontWeight: 500, color: isWeekend(day) ? "#e65100" : "#0d47a1" }}>
                                            {fmtRange(range)}
                                          </Typography>
                                        )}
                                      </Box>
                                    );
                                  })}
                                </Box>
                              </>
                            )}
                          </Box>
                        </Grid>
                      );
                    })}
                  </Grid>
                )}
              </Box>
            </Box>
          )}
          {/* ── ORDERS TAB ───────────────────────────────────────────── */}
          {activeTab === 2 && (
            <Box>
              {/* Toolbar */}
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2.5, py: 1.75, borderBottom: "1px solid #f0f0f5", flexWrap: "wrap", gap: 1 }}>
                {/* Status filters */}
                <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap" }}>
                  {["all","pending","confirmed","processing","delivered","cancelled"].map((s) => (
                    <Chip
                      key={s}
                      label={s === "all" ? `All (${shopOrders.length})` : `${s.charAt(0).toUpperCase()}${s.slice(1)} (${shopOrders.filter(o=>o.status===s).length})`}
                      size="small"
                      onClick={() => setOrderStatusFilter(s)}
                      sx={{
                        fontSize: 11, cursor: "pointer",
                        bgcolor: orderStatusFilter === s
                          ? (s === "all" ? "#3949ab" : (ORDER_STATUS_COLOR[s]?.bg ?? "#eee"))
                          : "#f5f5f5",
                        color: orderStatusFilter === s
                          ? (s === "all" ? "#fff" : (ORDER_STATUS_COLOR[s]?.color ?? "#333"))
                          : "#666",
                        fontWeight: orderStatusFilter === s ? 700 : 400,
                        border: orderStatusFilter === s ? `1px solid ${s === "all" ? "#3949ab" : (ORDER_STATUS_COLOR[s]?.color ?? "#ccc")}` : "1px solid transparent",
                      }}
                    />
                  ))}
                </Box>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Button
                    variant="contained"
                    className={classes.addButton}
                    onClick={() => setOpenOrderModal(true)}
                    startIcon={<span style={{ fontSize: 18, lineHeight: 1 }}>+</span>}
                  >
                    New Order
                  </Button>
                </Box>
              </Box>

              {/* Orders table */}
              {filteredOrders.length === 0 ? (
                <Box textAlign="center" py={7} sx={{ background: "#f8f9ff", m: 2, borderRadius: "12px", border: "2px dashed #c5cae9" }}>
                  <ShoppingCartOutlinedIcon sx={{ fontSize: 44, color: "#c5cae9", mb: 1 }} />
                  <Typography fontSize={14} color="text.secondary" fontWeight={500}>No orders yet</Typography>
                  <Typography fontSize={12} color="text.disabled" mb={2}>
                    No orders have been placed yet
                  </Typography>
                  <Button variant="contained" className={classes.addButton} onClick={() => setOpenOrderModal(true)}>
                    Create Order
                  </Button>
                </Box>
              ) : (
                <TableContainer>
                  <Table className={classes.table}>
                    <TableHead className={classes.tableHeaderRow}>
                      <TableRow>
                        <TableCell className={classes.tablheader}><strong>#</strong></TableCell>
                        <TableCell className={classes.tablheader}><strong>Date</strong></TableCell>
                        <TableCell className={classes.tablheader}><strong>Items</strong></TableCell>
                        <TableCell className={classes.tablheader}><strong>Total</strong></TableCell>
                        <TableCell className={classes.tablheader}><strong>Notes</strong></TableCell>
                        <TableCell className={classes.tablheader}><strong>Status</strong></TableCell>
                        <TableCell className={classes.tablheader} sx={{ textAlign: "right" }}><strong>Actions</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredOrders.map((order, i) => {
                        const sc = ORDER_STATUS_COLOR[order.status] ?? { bg: "#f5f5f5", color: "#666" };
                        return (
                          <TableRow key={order.id} className={classes.tableRowHover}>
                            <TableCell className={classes.tablCell}>{i + 1}</TableCell>
                            <TableCell className={classes.tablCell}>
                              <Typography fontSize={12}>{dayjs(order.order_date || order.created_at).format("MMM D, YYYY")}</Typography>
                              <Typography fontSize={11} color="text.secondary">{dayjs(order.created_at).format("h:mm A")}</Typography>
                            </TableCell>
                            <TableCell className={classes.tablCell}>
                              <Typography fontSize={13} fontWeight={600}>{order.items.length} item{order.items.length !== 1 ? "s" : ""}</Typography>
                              <Typography fontSize={11} color="text.secondary" noWrap sx={{ maxWidth: 200 }}>
                                {order.items.slice(0, 3).map(it => `${it.name} ×${it.qty}`).join(", ")}
                                {order.items.length > 3 && ` +${order.items.length - 3} more`}
                              </Typography>
                            </TableCell>
                            <TableCell className={classes.tablCell}>
                              <Typography fontSize={13} fontWeight={700} color="#2e7d32">${Number(order.total).toFixed(2)}</Typography>
                            </TableCell>
                            <TableCell className={classes.tablCell}>
                              <Typography fontSize={12} color="text.secondary" sx={{ maxWidth: 160 }} noWrap>
                                {order.notes || "—"}
                              </Typography>
                            </TableCell>
                            <TableCell className={classes.tablCell}>
                              <Select
                                size="small"
                                value={order.status}
                                onChange={async (e) => {
                                  try {
                                    await updateShopOrderStatus({ orderId: order.id, status: e.target.value }).unwrap();
                                    showMessage("Status updated");
                                    refetchOrders();
                                    loadCreditStatus();
                                    loadInvoices();
                                  } catch {
                                    showErrorMessage("Failed to update status");
                                  }
                                }}
                                sx={{
                                  fontSize: 11, fontWeight: 700, borderRadius: "20px",
                                  bgcolor: sc.bg, color: sc.color,
                                  "& .MuiOutlinedInput-notchedOutline": { borderColor: sc.color, opacity: 0.4 },
                                  "& .MuiSelect-icon": { color: sc.color },
                                  "& .MuiSelect-select": { py: 0.5, px: 1.5, pr: "28px !important" },
                                }}
                              >
                                {["pending","confirmed","processing","delivered","cancelled"].map((s) => (
                                  <MenuItem key={s} value={s} sx={{ fontSize: 12 }}>
                                    {s.charAt(0).toUpperCase() + s.slice(1)}
                                  </MenuItem>
                                ))}
                              </Select>
                            </TableCell>
                            <TableCell className={classes.tablCell} sx={{ textAlign: "right" }}>
                              <Button
                                variant="contained" size="small"
                                onClick={() => navigate(`/shop-order/${order.id}`)}
                                sx={{ minWidth: 32, width: 32, height: 32, p: 0, borderRadius: "8px", background: "linear-gradient(135deg, #3949ab 0%, #5c6bc0 100%)", boxShadow: "none", "&:hover": { boxShadow: "none" } }}
                              >
                                <VisibilitySharpIcon sx={{ fontSize: 15 }} />
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Box>
          )}

          {/* ── INVOICES & PAYMENTS TAB ────────────────────────────── */}
          {activeTab === 3 && (
            <Box>
              {loadingInvoices ? (
                <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}><CircularProgress size={28} /></Box>
              ) : (
                <>
                  {/* Summary Cards */}
                  {invoiceSummary && (
                    <Box sx={{ display: "flex", gap: 2, px: 2.5, py: 2, flexWrap: "wrap", borderBottom: "1px solid #f0f0f5" }}>
                      {[
                        { label: "Total Invoiced", value: `$${invoiceSummary.total_invoiced?.toFixed(2) || "0.00"}`, color: "#1565C0", bg: "#E3F2FD" },
                        { label: "Total Paid", value: `$${invoiceSummary.total_paid?.toFixed(2) || "0.00"}`, color: "#2E7D32", bg: "#E8F5E9" },
                        { label: "Outstanding", value: `$${invoiceSummary.total_outstanding?.toFixed(2) || "0.00"}`, color: invoiceSummary.total_outstanding > 0 ? "#E65100" : "#2E7D32", bg: invoiceSummary.total_outstanding > 0 ? "#FFF3E0" : "#E8F5E9" },
                        { label: "Credit Balance", value: `$${invoiceSummary.credit_balance?.toFixed(2) || "0.00"}`, color: invoiceSummary.credit_balance > 0 ? "#2E7D32" : "#999", bg: invoiceSummary.credit_balance > 0 ? "#E8F5E9" : "#FAFAFA" },
                      ].map(c => (
                        <Paper key={c.label} elevation={0} sx={{ px: 2, py: 1.25, borderRadius: 2, border: "1px solid #eee", flex: 1, minWidth: 120 }}>
                          <Typography fontSize={10} color="#999" fontWeight={600} textTransform="uppercase">{c.label}</Typography>
                          <Typography fontSize={16} fontWeight={800} color={c.color}>{c.value}</Typography>
                        </Paper>
                      ))}
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75, alignSelf: "center" }}>
                        <Button variant="contained" size="small" startIcon={<PaymentIcon />} onClick={() => setBulkPaymentOpen(true)}
                          disabled={!invoiceSummary.total_outstanding || invoiceSummary.total_outstanding <= 0}
                          sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, fontSize: 12, bgcolor: "#009688", "&:hover": { bgcolor: "#00796B" } }}>
                          Record Payment
                        </Button>
                        {invoiceSummary.credit_balance > 0 && invoiceSummary.total_outstanding > 0 && (
                          <Button variant="outlined" size="small" onClick={handleApplyCredit}
                            sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, fontSize: 11, borderColor: "#009688", color: "#009688" }}>
                            Apply Credit
                          </Button>
                        )}
                      </Box>
                    </Box>
                  )}

                  {/* Invoice Table */}
                  {shopInvoices.length === 0 ? (
                    <Box sx={{ textAlign: "center", py: 6 }}>
                      <Typography fontSize={14} color="text.secondary">No invoices yet</Typography>
                    </Box>
                  ) : (
                    <TableContainer>
                      <Table size="small">
                        <TableHead>
                          <TableRow sx={{ bgcolor: "#FAFAFA" }}>
                            {["Invoice #", "Date", "Order", "Total", "Paid", "Balance", "Status", ""].map(h => (
                              <TableCell key={h} sx={{ fontWeight: 700, fontSize: 11, color: "#888", py: 1.25 }}>{h}</TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {shopInvoices.map((inv: any) => {
                            const statusColors: Record<string, { bg: string; color: string }> = {
                              unpaid: { bg: "#FFF3E0", color: "#E65100" },
                              partial: { bg: "#E3F2FD", color: "#1565C0" },
                              paid: { bg: "#E8F5E9", color: "#1B5E20" },
                            };
                            const sc = statusColors[inv.payment_status] || statusColors.unpaid;
                            return (
                              <TableRow key={inv.id} sx={{ "&:hover": { bgcolor: "#fafafa" }, cursor: "pointer" }}
                                onClick={() => navigate(`/shop-invoice/${inv.id}`)}>
                                <TableCell sx={{ fontSize: 13, fontWeight: 600 }}>{inv.invoice_number}</TableCell>
                                <TableCell sx={{ fontSize: 12 }}>{dayjs(inv.invoice_date).format("MMM D, YYYY")}</TableCell>
                                <TableCell sx={{ fontSize: 12, color: "#666" }}>#{inv.shop_order_id}</TableCell>
                                <TableCell sx={{ fontSize: 13, fontWeight: 700 }}>${inv.total?.toFixed(2)}</TableCell>
                                <TableCell sx={{ fontSize: 13, color: "#2E7D32", fontWeight: 600 }}>${inv.amount_paid?.toFixed(2)}</TableCell>
                                <TableCell sx={{ fontSize: 13, fontWeight: 700, color: inv.balance_due > 0 ? "#E65100" : "#2E7D32" }}>${inv.balance_due?.toFixed(2)}</TableCell>
                                <TableCell>
                                  <Chip label={inv.payment_status.charAt(0).toUpperCase() + inv.payment_status.slice(1)} size="small"
                                    sx={{ fontSize: 10, fontWeight: 700, bgcolor: sc.bg, color: sc.color, height: 22, borderRadius: "11px" }} />
                                </TableCell>
                                <TableCell>
                                  <IconButton size="small" sx={{ color: "#bbb", "&:hover": { color: "#009688" } }}>
                                    <VisibilitySharpIcon sx={{ fontSize: 16 }} />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}

                  {/* Payment History */}
                  {shopInvoices.some((inv: any) => inv.payments?.length > 0) && (
                    <Box sx={{ px: 2.5, py: 2 }}>
                      <Typography fontWeight={700} fontSize={14} mb={1.5}>Payment History</Typography>
                      <Table size="small">
                        <TableHead>
                          <TableRow sx={{ bgcolor: "#FAFAFA" }}>
                            {["Date", "Invoice", "Amount", "Method", "Notes"].map(h => (
                              <TableCell key={h} sx={{ fontWeight: 700, fontSize: 11, color: "#888", py: 1 }}>{h}</TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {shopInvoices.flatMap((inv: any) =>
                            (inv.payments || []).map((p: any) => ({
                              ...p, invoice_number: inv.invoice_number,
                            }))
                          ).sort((a: any, b: any) => new Date(b.payment_date).getTime() - new Date(a.payment_date).getTime())
                          .map((p: any) => (
                            <TableRow key={p.id}>
                              <TableCell sx={{ fontSize: 12 }}>{dayjs(p.payment_date).format("MMM D, YYYY")}</TableCell>
                              <TableCell sx={{ fontSize: 12, color: "#666" }}>{p.invoice_number}</TableCell>
                              <TableCell sx={{ fontSize: 13, fontWeight: 700, color: "#2E7D32" }}>${p.amount?.toFixed(2)}</TableCell>
                              <TableCell sx={{ fontSize: 12 }}>{p.payment_method}</TableCell>
                              <TableCell sx={{ fontSize: 11, color: "#999" }}>{p.notes || "—"}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </Box>
                  )}
                </>
              )}
            </Box>
          )}
        </Card>
      </Box>

      {/* ── DIALOGS ──────────────────────────────────────────────────── */}
      {/* Bulk Payment Dialog */}
      <Dialog open={bulkPaymentOpen} onClose={() => setBulkPaymentOpen(false)} maxWidth="sm" fullWidth>
        <Box sx={{ p: 3 }}>
          <Typography fontWeight={700} fontSize={17} mb={0.5}>Record Payment</Typography>
          <Typography fontSize={12} color="text.secondary" mb={2}>
            Select invoices or leave unchecked to apply FIFO.
            {invoiceSummary?.credit_balance > 0 && (
              <Chip label={`Credit: $${invoiceSummary.credit_balance.toFixed(2)}`} size="small" sx={{ ml: 1, fontSize: 10, fontWeight: 700, bgcolor: "#E8F5E9", color: "#2E7D32", height: 20 }} />
            )}
          </Typography>

          {/* Invoice Selection */}
          {(() => {
            const unpaidInvoices = shopInvoices.filter((inv: any) => inv.payment_status !== "paid");
            const selectedTotal = unpaidInvoices.filter((inv: any) => selectedInvoiceIds.has(inv.id)).reduce((s: number, inv: any) => s + (inv.balance_due || 0), 0);
            const paymentAmount = parseFloat(bulkAmount) || 0;
            const diff = paymentAmount - (selectedInvoiceIds.size > 0 ? selectedTotal : (invoiceSummary?.total_outstanding || 0));

            return (
              <>
                {unpaidInvoices.length > 0 && (
                  <Paper elevation={0} sx={{ border: "1px solid #e8e8e8", borderRadius: 2, mb: 2, maxHeight: 200, overflow: "auto" }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow sx={{ bgcolor: "#FAFAFA" }}>
                          <TableCell sx={{ width: 36, p: 0.5 }} />
                          <TableCell sx={{ fontWeight: 700, fontSize: 10, color: "#aaa", py: 0.75 }}>Invoice</TableCell>
                          <TableCell sx={{ fontWeight: 700, fontSize: 10, color: "#aaa", py: 0.75 }}>Total</TableCell>
                          <TableCell sx={{ fontWeight: 700, fontSize: 10, color: "#aaa", py: 0.75, textAlign: "right" }}>Balance</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {unpaidInvoices.map((inv: any) => (
                          <TableRow key={inv.id} sx={{ "&:hover": { bgcolor: "#fafafa" }, bgcolor: selectedInvoiceIds.has(inv.id) ? "#F1F8F6" : undefined }}>
                            <TableCell sx={{ p: 0.5 }}>
                              <Checkbox size="small" checked={selectedInvoiceIds.has(inv.id)}
                                onChange={() => setSelectedInvoiceIds(prev => { const n = new Set(prev); n.has(inv.id) ? n.delete(inv.id) : n.add(inv.id); return n; })}
                                sx={{ p: 0, "& .MuiSvgIcon-root": { fontSize: 18 } }} />
                            </TableCell>
                            <TableCell sx={{ fontSize: 12, fontWeight: 600 }}>{inv.invoice_number}</TableCell>
                            <TableCell sx={{ fontSize: 12 }}>${inv.total?.toFixed(2)}</TableCell>
                            <TableCell sx={{ fontSize: 12, fontWeight: 700, color: "#E65100", textAlign: "right" }}>${inv.balance_due?.toFixed(2)}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Paper>
                )}

                {/* Real-time Summary */}
                <Paper elevation={0} sx={{ p: 1.5, mb: 2, borderRadius: 2, bgcolor: "#FAFAFA", border: "1px solid #e8e8e8" }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                    <Typography fontSize={12} color="#999">{selectedInvoiceIds.size > 0 ? `Selected (${selectedInvoiceIds.size})` : "All Outstanding"}</Typography>
                    <Typography fontSize={12} fontWeight={600}>${(selectedInvoiceIds.size > 0 ? selectedTotal : (invoiceSummary?.total_outstanding || 0)).toFixed(2)}</Typography>
                  </Box>
                  {paymentAmount > 0 && (
                    <>
                      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                        <Typography fontSize={12} color="#999">Payment</Typography>
                        <Typography fontSize={12} fontWeight={600} color="#009688">${paymentAmount.toFixed(2)}</Typography>
                      </Box>
                      <Divider sx={{ my: 0.5 }} />
                      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography fontSize={12} fontWeight={700} color={diff > 0 ? "#2E7D32" : diff < 0 ? "#E65100" : "#333"}>
                          {diff > 0 ? "Overpayment (→ Credit)" : diff < 0 ? "Remaining Balance" : "Exact Match"}
                        </Typography>
                        <Typography fontSize={12} fontWeight={700} color={diff > 0 ? "#2E7D32" : diff < 0 ? "#E65100" : "#333"}>
                          ${Math.abs(diff).toFixed(2)}
                        </Typography>
                      </Box>
                    </>
                  )}
                </Paper>
              </>
            );
          })()}

          {/* Payment Input */}
          <TextField fullWidth size="small" label="Payment Amount" type="number" value={bulkAmount} onChange={(e) => setBulkAmount(e.target.value)}
            InputProps={{ startAdornment: <Typography sx={{ fontSize: 13, color: "#999", mr: 0.5 }}>$</Typography> }}
            sx={{ mb: 2, "& .MuiOutlinedInput-root": { borderRadius: 2 } }} />
          <Box sx={{ display: "flex", gap: 1.5, mb: 2 }}>
            <TextField fullWidth size="small" select label="Method" value={bulkMethod} onChange={(e) => setBulkMethod(e.target.value)}
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2 } }}>
              {["Cash", "Bank Transfer", "E-Transfer", "Cheque", "Card", "Other"].map(m => <MenuItem key={m} value={m}>{m}</MenuItem>)}
            </TextField>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Date"
                value={bulkDate ? dayjs(bulkDate) : null}
                onChange={(v: any) => setBulkDate(v ? v.format("YYYY-MM-DD") : "")}
                format="YYYY-MM-DD"
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    placeholder: "Select date",
                    InputProps: {
                      startAdornment: <CalendarMonthIcon sx={{ fontSize: 18, mr: 1, color: "#64748b" }} />,
                    },
                    sx: {
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        bgcolor: "#f8fafc",
                        fontSize: 14,
                        transition: "all 0.2s ease",
                        "& fieldset": { borderColor: "#e2e8f0" },
                        "&:hover fieldset": { borderColor: "#1e293b" },
                        "&.Mui-focused fieldset": { borderColor: "#0f172a", boxShadow: "0 0 0 3px rgba(15,23,42,0.1)" },
                      },
                    },
                  },
                  popper: {
                    sx: {
                      zIndex: 2000,
                      "& .MuiPaper-root": { borderRadius: "16px", boxShadow: "0 20px 50px rgba(0,0,0,0.15)", p: 1, mt: 0.5 },
                      "& .MuiPickersDay-root.Mui-selected": { bgcolor: "#0f172a", color: "#fff", "&:hover": { bgcolor: "#1e293b" }, "&:focus": { bgcolor: "#0f172a" } },
                      "& .MuiPickersDay-root:hover": { bgcolor: "rgba(15,23,42,0.08)" },
                      "& .MuiPickersDay-today": { borderColor: "#0f172a" },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Box>
          <TextField fullWidth size="small" label="Notes (optional)" value={bulkNotes} onChange={(e) => setBulkNotes(e.target.value)}
            sx={{ mb: 2, "& .MuiOutlinedInput-root": { borderRadius: 2 } }} />
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button variant="outlined" onClick={() => { setBulkPaymentOpen(false); setSelectedInvoiceIds(new Set()); }} sx={{ borderRadius: 2, textTransform: "none", borderColor: "#ccc", color: "#666" }}>Cancel</Button>
            <Button variant="contained" disabled={savingBulkPayment || !bulkAmount || parseFloat(bulkAmount) <= 0} onClick={handleBulkPayment}
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, bgcolor: "#009688", "&:hover": { bgcolor: "#00796B" } }}>
              {savingBulkPayment ? "Processing..." : "Record Payment"}
            </Button>
          </Box>
        </Box>
      </Dialog>

      {/* Credit Settings Dialog */}
      <Dialog open={creditDialogOpen} onClose={() => setCreditDialogOpen(false)} maxWidth="xs" fullWidth>
        <Box sx={{ p: 3 }}>
          <Typography fontWeight={700} fontSize={16} mb={2}>Credit Settings</Typography>
          <TextField fullWidth size="small" label="Credit Limit ($)" type="number" value={editCreditLimit}
            onChange={(e) => setEditCreditLimit(e.target.value)}
            helperText="Set to 0 for no credit limit"
            InputProps={{ startAdornment: <Typography sx={{ fontSize: 13, color: "#999", mr: 0.5 }}>$</Typography> }}
            sx={{ mb: 2, "& .MuiOutlinedInput-root": { borderRadius: 2 } }} />
          <TextField fullWidth size="small" select label="Credit Terms" value={editCreditTerms}
            onChange={(e) => setEditCreditTerms(e.target.value)}
            sx={{ mb: 2, "& .MuiOutlinedInput-root": { borderRadius: 2 } }}>
            <MenuItem value="no_limit">No Limit (no due date enforcement)</MenuItem>
            <MenuItem value="net_7">Net 7 (due within 7 days)</MenuItem>
            <MenuItem value="net_15">Net 15 (due within 15 days)</MenuItem>
            <MenuItem value="net_30">Net 30 (due within 30 days)</MenuItem>
          </TextField>

          {/* Block toggle */}
          <Paper elevation={0} sx={{ p: 1.5, borderRadius: 2, border: "1px solid #eee", mb: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Box>
                <Typography fontSize={13} fontWeight={600} color="#333">Block Orders Manually</Typography>
                <Typography fontSize={11} color="#999">When enabled, restaurant cannot place any orders</Typography>
              </Box>
              <IOSSwitch checked={editCreditBlocked} onChange={(e) => setEditCreditBlocked(e.target.checked)} />
            </Box>
          </Paper>

          <Typography fontSize={11} color="#999" mb={2}>
            When credit limit is exceeded: orders are automatically blocked. Unblock by recording a payment or increasing the limit.
          </Typography>

          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button variant="outlined" onClick={() => setCreditDialogOpen(false)}
              sx={{ borderRadius: 2, textTransform: "none", borderColor: "#ccc", color: "#666" }}>Cancel</Button>
            <Button variant="contained" disabled={savingCredit} onClick={handleSaveCreditSettings}
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, bgcolor: "#009688", "&:hover": { bgcolor: "#00796B" } }}>
              {savingCredit ? "Saving..." : "Save Settings"}
            </Button>
          </Box>
        </Box>
      </Dialog>

      {/* Create Order dialog */}
      <Dialog open={openOrderModal} onClose={() => setOpenOrderModal(false)} maxWidth="sm" fullWidth>
        <Box sx={{ p: 3 }}>
          <Typography fontWeight={700} fontSize={16} mb={2}>Create Order</Typography>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
    label="Order Date"
    value={orderDate ? dayjs(orderDate) : null}
    onChange={(v: any) => setOrderDate(v ? v.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD"))}
    format="YYYY-MM-DD"
    slotProps={{
      textField: {
        fullWidth: true,
        size: "small",
        InputProps: {
          startAdornment: (
            <CalendarMonthIcon sx={{ fontSize: 18, mr: 1, color: "#64748b" }} />
          ),
        },
        sx: {
          mb: 2,
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            bgcolor: "#f8fafc",
            fontSize: 14,
            "& fieldset": { borderColor: "#e2e8f0" },
            "&:hover fieldset": { borderColor: "#1e293b" },
            "&.Mui-focused fieldset": { borderColor: "#0f172a" },
          },
        },
      },
    }}
  />
</LocalizationProvider>

        
          <TableContainer sx={{ maxHeight: 360, mb: 2 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell><strong>Product</strong></TableCell>
                  <TableCell align="center"><strong>Price</strong></TableCell>
                  <TableCell align="center"><strong>Qty</strong></TableCell>
                  <TableCell align="right"><strong>Subtotal</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredShopProducts.map((p) => {
                  const sp = shopProductMap.get(Number(p.id));
                  const price = sp?.custom_price != null ? Number(sp.custom_price) : Number(p.wholesaleprice ?? p.productPrice ?? 0);
                  const qty = orderCart[Number(p.id)] || 0;
                  return (
                    <TableRow key={p.id}>
                      <TableCell>
                        <Typography fontSize={12} fontWeight={500}>{p.productName}</Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography fontSize={12} color="#1565c0" fontWeight={600}>${price.toFixed(2)}</Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }}>
                          <Button size="small" onClick={() => setOrderCart(c => ({ ...c, [Number(p.id)]: Math.max(0, (c[Number(p.id)] || 0) - 1) }))}
                            sx={{ minWidth: 24, width: 24, height: 24, p: 0, borderRadius: "6px", bgcolor: "#f5f5f5", color: "#555", "&:hover": { bgcolor: "#e0e0e0" } }}>
                            –
                          </Button>
                          <Typography fontSize={13} fontWeight={600} sx={{ width: 28, textAlign: "center" }}>{qty}</Typography>
                          <Button size="small" onClick={() => setOrderCart(c => ({ ...c, [Number(p.id)]: (c[Number(p.id)] || 0) + 1 }))}
                            sx={{ minWidth: 24, width: 24, height: 24, p: 0, borderRadius: "6px", bgcolor: "#e8eaf6", color: "#3949ab", "&:hover": { bgcolor: "#c5cae9" } }}>
                            +
                          </Button>
                        </Box>
                      </TableCell>
                      <TableCell align="right">
                        <Typography fontSize={12} fontWeight={qty > 0 ? 700 : 400} color={qty > 0 ? "#2e7d32" : "text.disabled"}>
                          {qty > 0 ? `$${(price * qty).toFixed(2)}` : "—"}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          {/* Total */}
          <Box sx={{ display: "flex", justifyContent: "space-between", px: 1, mb: 2 }}>
            <Typography fontWeight={700} fontSize={14}>Total</Typography>
            <Typography fontWeight={800} fontSize={14} color="#2e7d32">
              ${filteredShopProducts.reduce((s, p) => {
                const sp = shopProductMap.get(Number(p.id));
                const price = sp?.custom_price != null ? Number(sp.custom_price) : Number(p.wholesaleprice ?? p.productPrice ?? 0);
                return s + price * (orderCart[Number(p.id)] || 0);
              }, 0).toFixed(2)}
            </Typography>
          </Box>
          <TextField
            size="small" fullWidth multiline rows={2}
            label="Order notes (optional)"
            value={orderNotes}
            onChange={(e) => setOrderNotes(e.target.value)}
            sx={{ mb: 2, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button variant="outlined" className={classes.addButton} onClick={() => { setOpenOrderModal(false); setOrderCart({}); setOrderNotes(""); setOrderDate(dayjs().format("YYYY-MM-DD"));}}>Cancel</Button>
            <Button
              variant="contained" className={classes.addButton}
              disabled={!filteredShopProducts.some((p) => (orderCart[Number(p.id)] || 0) > 0) || submittingOrder}
              onClick={handleSubmitOrder}
            >
              {submittingOrder ? "Saving..." : "Submit Order"}
            </Button>
          </Box>
        </Box>
      </Dialog>

      {/* Edit Order dialog */}
      {viewOrder && (
        <Dialog open={!!viewOrder} onClose={() => setViewOrder(null)} maxWidth="md" fullWidth>
          <Box sx={{ p: 3 }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography fontWeight={700} fontSize={17}>Order #{viewOrder.id}</Typography>
                <Chip
                  label={viewOrder.status.charAt(0).toUpperCase() + viewOrder.status.slice(1)}
                  size="small"
                  sx={{ fontSize: 11, fontWeight: 700, bgcolor: ORDER_STATUS_COLOR[viewOrder.status]?.bg, color: ORDER_STATUS_COLOR[viewOrder.status]?.color }}
                />
              </Box>
              <Typography fontSize={12} color="text.secondary">{dayjs(viewOrder.created_at).format("MMM D, YYYY h:mm A")}</Typography>
            </Box>

            {viewOrder.portal_note && (
              <Alert severity="info" sx={{ mb: 2, borderRadius: 2, fontSize: 13 }}>
                <strong>Restaurant note:</strong> {viewOrder.portal_note}
              </Alert>
            )}

            <TableContainer sx={{ border: "1px solid #e0e0e0", borderRadius: 2, mb: 2, maxHeight: 350, overflow: "auto" }}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ bgcolor: "#f5f5f5" }}>
                    <TableCell sx={{ fontWeight: 700, fontSize: 12 }}>#</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: 12 }}>Product</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: 12, width: 90 }}>Qty</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: 12, width: 60 }}>Unit</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: 12, width: 100 }}>Price</TableCell>
                    <TableCell sx={{ fontWeight: 700, fontSize: 12, width: 90, textAlign: "right" }}>Subtotal</TableCell>
                    <TableCell sx={{ width: 40 }}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {editOrderItems.map((item, i) => (
                    <TableRow key={i}>
                      <TableCell sx={{ fontSize: 12, color: "#999" }}>{i + 1}</TableCell>
                      <TableCell sx={{ fontSize: 13, fontWeight: 500 }}>{item.name}</TableCell>
                      <TableCell>
                        <TextField size="small" type="number"
                          value={item.qty}
                          onChange={(e) => handleEditItemQty(i, e.target.value)}
                          inputProps={{ min: 0, step: "0.1", style: { fontSize: 13, padding: "5px 8px" } }}
                          sx={{ width: 75, "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
                        />
                      </TableCell>
                      <TableCell>
                        <Typography fontSize={12} color="text.secondary">{(item as any).unit || "-"}</Typography>
                      </TableCell>
                      <TableCell>
                        <TextField size="small" type="number"
                          value={item.price}
                          onChange={(e) => handleEditItemPrice(i, e.target.value)}
                          inputProps={{ min: 0, step: "0.01", style: { fontSize: 13, padding: "5px 8px" } }}
                          sx={{ width: 85, "& .MuiOutlinedInput-root": { borderRadius: 1.5 } }}
                          InputProps={{ startAdornment: <Typography sx={{ fontSize: 12, color: "#999", mr: 0.25 }}>$</Typography> }}
                        />
                      </TableCell>
                      <TableCell sx={{ textAlign: "right" }}>
                        <Typography fontSize={13} fontWeight={600}>${item.subtotal.toFixed(2)}</Typography>
                      </TableCell>
                      <TableCell>
                        <IconButton size="small" onClick={() => handleRemoveItem(i)} sx={{ color: "#ccc", "&:hover": { color: "#d32f2f" } }}>
                          <CloseIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2, pr: 1 }}>
              <Typography fontWeight={700} fontSize={16}>Total: <span style={{ color: "#2e7d32" }}>${editOrderTotal.toFixed(2)}</span></Typography>
            </Box>

            <TextField size="small" fullWidth multiline rows={2} label="Notes"
              value={editOrderNotes} onChange={(e) => setEditOrderNotes(e.target.value)}
              sx={{ mb: 2, "& .MuiOutlinedInput-root": { borderRadius: 2 } }}
            />

            <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 1 }}>
              <Button variant="outlined" onClick={handlePrintInvoice}
                sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, borderColor: "#ccc", color: "#333" }}>
                Print
              </Button>
              <Button variant="contained"
                onClick={async () => {
                  if (!viewOrder) return;
                  try {
                    const res = await createShopInvoice({ shop_order_id: viewOrder.id }).unwrap();
                    if (res.success) {
                      setViewOrder(null);
                      navigate(`/shop-invoice/${res.data.id}`);
                    }
                  } catch (e: any) { showErrorMessage(e.data?.message || "Failed to create invoice"); }
                }}
                sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, bgcolor: "#1a237e", "&:hover": { bgcolor: "#0d1257" } }}>
                Generate Invoice
              </Button>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button variant="outlined" onClick={() => setViewOrder(null)}
                  sx={{ borderRadius: 2, textTransform: "none", borderColor: "#ccc", color: "#666" }}>
                  Cancel
                </Button>
                <Button variant="contained" disabled={savingOrder} onClick={() => handleSaveEditedOrder()}
                  sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, bgcolor: "#3949ab", "&:hover": { bgcolor: "#1a237e" } }}>
                  {savingOrder ? "Saving..." : "Save Changes"}
                </Button>
                {viewOrder.status === "pending" && (
                  <Button variant="contained" disabled={savingOrder} onClick={() => handleSaveEditedOrder("confirmed")}
                    sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600, bgcolor: "#2e7d32", "&:hover": { bgcolor: "#1b5e20" } }}>
                    Confirm & Finalize
                  </Button>
                )}
              </Box>
            </Box>
          </Box>
        </Dialog>
      )}
      {/* Edit now navigates to /product/edit/:id */}
      {productToDelete && (
        <DeletePopup
          open={openDeleteProduct}
          handleCloseDelete={handleCloseDeletePopup}
          onConfirm={async () => { await handleDelete(productToDelete.id.toString()); }}
          title="Delete Product"
          content={`Are you sure you want to delete "${productToDelete.productName}"?`}
        />
      )}

      {openDialogShop && (
        <CreateShopProduct
          openModel={openDialogShop}
          shopId={Number(CategoryId)}
          selectedShopProducts={selectedShopProducts}
          setSelectedShopProducts={setSelectedShopProducts}
          handleCloseDialog={handleClose}
          onSuccess={() => refetch()}
        />
      )}

      {/* ── RESET PASSWORD CONFIRM DIALOG ─────────────────────────────── */}
      <Dialog
        open={resetPwdDialogOpen}
        onClose={() => !portalBusy && setResetPwdDialogOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 10px 30px rgba(15,23,42,0.12)" } }}
        BackdropProps={{ sx: { bgcolor: "rgba(0,0,0,0.4)" } }}
      >
        <DialogTitle sx={{ fontWeight: 700, fontSize: 16, color: "#0f172a", pb: 1 }}>Reset Password</DialogTitle>
        <DialogContent>
          <Typography fontSize={13} color="#475569" lineHeight={1.6}>
            This will generate a new temporary password.
          </Typography>
          <Typography fontSize={13} color="#475569" lineHeight={1.6} mt={0.75}>
            The current password will stop working immediately.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.25, gap: 1 }}>
          <Button
            onClick={() => setResetPwdDialogOpen(false)}
            disabled={portalBusy}
            variant="outlined"
            sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, borderColor: "#e2e8f0", color: "#475569", "&:hover": { borderColor: "#cbd5e1", bgcolor: "#f8fafc" } }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleAdminResetPortalPwd}
            disabled={portalBusy}
            variant="contained"
            disableElevation
            sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, bgcolor: "#1e293b", "&:hover": { bgcolor: "#0f172a" } }}
          >
            {portalBusy ? "Generating..." : "Generate Password"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── RESET PASSWORD RESULT DIALOG (editable + regenerate) ──────── */}
      <Dialog
        open={resetPwdResultOpen}
        onClose={() => { if (portalBusy || savingTempPwd) return; setResetPwdResultOpen(false); setPortalTempPwd(null); setTempPwdInput(""); }}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 10px 30px rgba(15,23,42,0.12)" } }}
        BackdropProps={{ sx: { bgcolor: "rgba(0,0,0,0.4)" } }}
      >
        <DialogTitle sx={{ fontWeight: 700, fontSize: 16, color: "#0f172a", pb: 1 }}>New Password Generated</DialogTitle>
        <DialogContent>
          <Typography fontSize={11} fontWeight={700} color="#64748b" textTransform="uppercase" letterSpacing={0.5} mb={0.75}>
            Password
          </Typography>
          <TextField
            fullWidth
            size="small"
            type={showTempPwd ? "text" : "password"}
            value={tempPwdInput}
            onChange={(e) => setTempPwdInput(e.target.value)}
            disabled={portalBusy || savingTempPwd}
            InputProps={{
              sx: { fontFamily: "monospace", fontSize: 15, fontWeight: 700, letterSpacing: 1, bgcolor: "#f8fafc", borderRadius: "8px" },
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={showTempPwd ? "Hide" : "Show"}>
                    <IconButton size="small" onClick={() => setShowTempPwd((v) => !v)} sx={{ color: "#475569" }}>
                      {showTempPwd ? <VisibilityOffIcon sx={{ fontSize: 17 }} /> : <VisibilityIcon sx={{ fontSize: 17 }} />}
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Copy">
                    <IconButton
                      size="small"
                      onClick={async () => { if (!tempPwdInput) return; try { await navigator.clipboard.writeText(tempPwdInput); showMessage("Password copied"); } catch { showErrorMessage("Could not copy"); } }}
                      sx={{ color: "#1e293b" }}
                    >
                      <ContentCopyIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Regenerate">
                    <span>
                      <IconButton
                        size="small"
                        onClick={handleAdminResetPortalPwd}
                        disabled={portalBusy || savingTempPwd}
                        sx={{ color: "#3949ab" }}
                      >
                        <RestartAltIcon sx={{ fontSize: 17 }} />
                      </IconButton>
                    </span>
                  </Tooltip>
                </InputAdornment>
              ),
            }}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
          />
          <Typography fontSize={11} color="#94a3b8" mt={0.5}>
            Edit, regenerate, or copy as needed. Click Save to apply.
          </Typography>
          <Alert severity="warning" sx={{ mt: 1.5, borderRadius: "8px", fontSize: 12, py: 0.5 }}>
            Shown only once. Copy and share it with the restaurant now — you won't see it again.
          </Alert>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.25, gap: 1 }}>
          <Button
            variant="outlined"
            onClick={() => { setResetPwdResultOpen(false); setPortalTempPwd(null); setTempPwdInput(""); }}
            disabled={portalBusy || savingTempPwd}
            sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, borderColor: "#e2e8f0", color: "#475569", "&:hover": { borderColor: "#cbd5e1", bgcolor: "#f8fafc" } }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disableElevation
            onClick={handleSaveEditedTempPwd}
            disabled={portalBusy || savingTempPwd || tempPwdInput.length < 6}
            sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, bgcolor: "#1e293b", "&:hover": { bgcolor: "#0f172a" } }}
          >
            {savingTempPwd ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── DISABLE ACCESS CONFIRM DIALOG ─────────────────────────────── */}
      <Dialog
        open={disableAccessDialogOpen}
        onClose={() => !portalBusy && setDisableAccessDialogOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", border: "1px solid #e2e8f0", boxShadow: "0 10px 30px rgba(15,23,42,0.12)" } }}
        BackdropProps={{ sx: { bgcolor: "rgba(0,0,0,0.4)" } }}
      >
        <DialogTitle sx={{ fontWeight: 700, fontSize: 16, color: "#0f172a", pb: 1 }}>Disable Portal Access</DialogTitle>
        <DialogContent>
          <Typography fontSize={13} color="#475569" lineHeight={1.6}>
            The restaurant will no longer be able to access the portal.
          </Typography>
          <Typography fontSize={13} color="#475569" lineHeight={1.6} mt={0.75}>
            You can re-enable access anytime.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.25, gap: 1 }}>
          <Button
            onClick={() => setDisableAccessDialogOpen(false)}
            disabled={portalBusy}
            variant="outlined"
            sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, borderColor: "#e2e8f0", color: "#475569", "&:hover": { borderColor: "#cbd5e1", bgcolor: "#f8fafc" } }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => performTogglePortalActive(false)}
            disabled={portalBusy}
            variant="contained"
            disableElevation
            sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 600, bgcolor: "#dc2626", "&:hover": { bgcolor: "#b91c1c" } }}
          >
            {portalBusy ? "Disabling..." : "Disable Access"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── PORTAL CREDENTIALS DIALOG ────────────────────────────────── */}
      <Dialog open={openPortalSetup} onClose={() => { setOpenPortalSetup(false); setPortalSetupMsg(""); }} maxWidth="xs" fullWidth>
        <Box sx={{ p: 3 }}>
          <Typography fontWeight={700} fontSize={16} mb={0.5}>Portal Access Setup</Typography>
          <Typography fontSize={13} color="text.secondary" mb={2.5}>
            Set login credentials for this restaurant's portal. Share the link and credentials with the shop owner.
          </Typography>
          {portalSetupMsg && (
            <Box sx={{ mb: 2, p: 1.5, bgcolor: "#e8f5e9", borderRadius: "8px", border: "1px solid #a5d6a7" }}>
              <Typography fontSize={13} color="#2e7d32" fontWeight={600}>{portalSetupMsg}</Typography>
              <Typography fontSize={12} color="#388e3c" mt={0.5} sx={{ wordBreak: "break-all" }}>
                Portal URL: {portalUrl}
              </Typography>
            </Box>
          )}
          <TextField
            size="small" fullWidth label="Portal Email"
            type="email"
            value={portalEmail}
            onChange={(e) => setPortalEmail(e.target.value)}
            sx={{ mb: 1.5, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
          />
          <TextField
            size="small" fullWidth label="Portal Password"
            type="password"
            value={portalPassword}
            onChange={(e) => setPortalPassword(e.target.value)}
            helperText="Minimum 6 characters"
            sx={{ mb: 2.5, "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
          />
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button variant="outlined" onClick={() => { setOpenPortalSetup(false); setPortalSetupMsg(""); }}
              sx={{ borderRadius: "8px", textTransform: "none", borderColor: "#c5cae9", color: "#555" }}>
              Cancel
            </Button>
            <Button
              variant="contained" disabled={savingPortal || !portalEmail || portalPassword.length < 6}
              onClick={async () => {
                const cleanEmail = (portalEmail || "").trim().toLowerCase();
                if (!cleanEmail || portalPassword.length < 6) {
                  showErrorMessage("Email is required and password must be at least 6 characters");
                  return;
                }
                setSavingPortal(true);
                try {
                  const token = localStorage.getItem("token") || "";
                  const res = await fetch(`${API_URL}/shops/${CategoryId}/portal-credentials`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest", Authorization: `Bearer ${token}` },
                    body: JSON.stringify({ portal_email: cleanEmail, portal_password: portalPassword }),
                  });
                  const data = await parseJsonSafely(res);
                  if (data.success) {
                    if (data.data?.portal_email) setPortalEmail(data.data.portal_email);
                    setPortalSetupMsg("Credentials saved! Share the portal link with the restaurant.");
                    setPortalPassword("");
                    showMessage("Portal credentials saved");
                    refetch();
                    loadPortalStatus();
                  } else {
                    showErrorMessage(data.message || "Failed to save credentials");
                  }
                } catch {
                  showErrorMessage("Failed to save credentials");
                } finally {
                  setSavingPortal(false);
                }
              }}
              sx={{ borderRadius: "8px", textTransform: "none", bgcolor: "#3949ab", "&:hover": { bgcolor: "#1a237e" } }}
            >
              {savingPortal ? "Saving..." : "Save Credentials"}
            </Button>
          </Box>
        </Box>
      </Dialog>

      {/* Add Route modal */}
      <Dialog open={openRouteModal} onClose={() => setOpenRouteModal(false)} maxWidth="sm" fullWidth>
        <Box sx={{ p: 3 }}>
          <Typography fontWeight={700} fontSize={16} mb={2}>Assign Route</Typography>
          <TextField
            size="small" fullWidth
            placeholder="Search routes..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <CiSearch style={{ fontSize: 16, color: "#999" }} />
                </InputAdornment>
              ),
            }}
            sx={{ mb: 1.5 }}
          />
          <Box sx={{ height: 320, overflowY: "auto", border: "1px solid #e8eaf0", borderRadius: "10px", p: 1 }}>
            {filteredRoutes.length === 0 ? (
              <Box textAlign="center" py={4}>
                <DirectionsIcon sx={{ fontSize: 36, color: "#c5cae9", mb: 1 }} />
                <Typography fontSize={13} color="text.secondary">No routes available</Typography>
              </Box>
            ) : (
              filteredRoutes.map((route: IRoutes) => {
                const selected = selectedRoutes.some((r) => r.id === route.id);
                return (
                  <Box
                    key={route.id}
                    onClick={() => {
                      if (selected) setSelectedRoutes(selectedRoutes.filter((r) => r.id !== route.id));
                      else setSelectedRoutes([...selectedRoutes, route]);
                    }}
                    sx={{
                      display: "flex", alignItems: "center", gap: 1.5,
                      p: 1.25, mb: 0.75, borderRadius: "8px", cursor: "pointer",
                      border: `1px solid ${selected ? "#90caf9" : "#f0f0f5"}`,
                      bgcolor: selected ? "#e3f2fd" : "#fff",
                      transition: "all 0.15s",
                    }}
                  >
                    <Box
                      sx={{
                        width: 32, height: 32, borderRadius: "8px", flexShrink: 0,
                        background: selected
                          ? "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)"
                          : "linear-gradient(135deg, #3f51b5 0%, #5c6bc0 100%)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                      }}
                    >
                      <DirectionsIcon sx={{ color: "#fff", fontSize: 16 }} />
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography fontSize={13} fontWeight={600} color={selected ? "#0d47a1" : "inherit"}>
                        {route.name}
                      </Typography>
                      {Array.isArray(route.cities) && route.cities.length > 0 && (
                        <Typography fontSize={11} color="text.secondary" noWrap>
                          {route.cities.slice(0, 4).join(", ")}
                          {route.cities.length > 4 && ` +${route.cities.length - 4} more`}
                        </Typography>
                      )}
                    </Box>
                    {selected && <CheckIcon sx={{ color: "#1976d2", fontSize: 18, flexShrink: 0 }} />}
                  </Box>
                );
              })
            )}
          </Box>
          {selectedRoutes.length > 0 && (
            <Typography fontSize={12} color="primary" mt={1}>
              {selectedRoutes.length} route{selectedRoutes.length > 1 ? "s" : ""} selected
            </Typography>
          )}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mt: 2 }}>
            <Button variant="outlined" className={classes.addButton} onClick={() => setOpenRouteModal(false)}>
              Cancel
            </Button>
            <Button
              variant="contained" className={classes.addButton}
              disabled={selectedRoutes.length === 0 || isAssigningRoute}
              onClick={() => { handleAssignRoutesToShop(selectedRoutes); setOpenRouteModal(false); }}
            >
              {isAssigningRoute ? "Saving..." : `Assign ${selectedRoutes.length > 0 ? `(${selectedRoutes.length})` : ""}`}
            </Button>
          </Box>
        </Box>
      </Dialog>

      {/* Edit Shop Dialog */}
      {openEditShop && product && (
        <NewPopUpCustomer
          openModel={openEditShop}
          handleCloseDialog={() => { setOpenEditShop(false); refetch(); }}
          data={product}
        />
      )}

    </Box>
  );
};

export default Index;

